// @ts-ignore - Ignore unused imports typescript error
import { ApiRequests, snApiRequests, makeApiRequests, LoginReq, LoginResp, UserProfile, UserMembership, ClientLogReq, UserForgotPasswordReq, UserResetPasswordActionReq, CreatePurchaserAndNomPurchaserReq, LocationsProductListingsReq, ProductListing, OrgLocationProductListingsReq, ThirdPartySaleFinishedProductListing, ThirdPartySaleFinishableProductListing, OrganisationReq, SaleOrderAckReq, SaleOrderCancelReq, SaleOrderCreateReq, SaleOrderCreateResp, NewStockNewDealReq, ExistingStockNewDealReq, SaleOrderReleaseReq, SaleOrderGetReq, SaleOrderDetailsView, ProductionOrderReq, ProductionOrderDetailsView, DealLegRepurchaseOrderReq, DealLegRepurchaseOrderPreview, SaleOrderPreviewReq, SaleOrderPreview, GetStorageLocationsReq, StorageLocationView, GetCarrierReq, OrgExistingProductsReq, ExistingProductsResp, StockDataReq, StockListing, StockDataCounts, GetAvailableStockReq, DetailedPhysicalStock, ProductBalancesReq, ProductBalance, ProductReservationsReq, ProductReservationsResp, StorageLocProductBalanceCSVReq, OrganisationAvailableStockReq, DealLegFspRequest, CalculatedFsp, CalculatedFspDetails, InvoiceListItem, PreviewProductionOrderTotalsReq, ProductionOrderTotals, ProductionOrderCreateReq, ProductionOrderCreateResp, CreateProductionOrderTaskRunReq, CreateProductionOrderTaskRunResp, RejectProductionOrderReq, ProductionOrderListingView, StorageLocationReq, SourceProductProductionServicesReq, FinishingServicesByOrgAndStorageLocReq, ProductSearchQueryReq, ProductDealLegSearchQueryReq, SearchQueryReq, SupplierPurchaseOrdersListingReq, SupplierAcceptNewDealRequestReq, SupplierNewDealRequestActionResp, SupplierUpdateNewDealRequestReq, NewDealRequestQueryReq, NewDealRequestQueryResp, AdminGetPurchaseRequestReq, PurchaseRequestView, AdminPurchaseRequestDetailsView, NewDealRequestDetailsReq, StorageLocNewDealRequestShipmentReq, StorageLocNewDealRequestShipmentResp, StorageLocConfirmDeliveryReq, StorageLocConfirmDeliveryResp, NewDealRequestCancellationResp, NewDealRequestsForCarrierReq, NewDealRequestsForOrganisationReq, InProgressNewDealRequestOverview, CarrierAdvanceNewDealReq, CarrierAdvanceNewDealResp, PreviewNewDealRequestProductLineItemsReq, PreviewNewDealRequestProductLineItemsResp, OrganisationPreviewNewDealRequestReq, OrganisationPreviewNewDealRequestResp, ConfirmNewDealRequestReq, ConfirmNewDealRequestResp, ConfirmExistingStockNewDealRequestReq, ConfirmExistingStockNewDealRequestResp, StockOwnershipTransferConfirmationReq, StockOwnershipTransferConfirmationRequestResp, PaymentTransferConfirmationReq, PaymentTransferConfirmationRequestResp, RejectNewDealRequestReq, RejectNewDealRequestResp, VoidNewDealReq, VoidNewDealResp, ConfirmPaymentNewDealRequestReq, ConfirmPaymentNewDealRequestResp, ConfirmSupplierPaymentNewDealRequestReq, OrganisationAdvanceNewStockNewDealRequestReq, OrganisationAdvanceNewDealRequestResp, OrganisationAdvanceExistingStockNewDealRequestReq, OrganisationStockReq, OrganisationProductInventoryView, OrganisationStockByProductIdsReq, CheckProductCodeReq, GetProductReq, GetProductResp, GetRatesCurveReq, GetRatesCurveResp, UpdateRatesCurveReq, UpdateRatesCurveResp, CreateCapitalisedExpenseReq, PreviewCapitalisedExpenseResp, CreateCapitalisedExpenseResp, ProductMovementReportReq, QrGenerateCodeResp, QrLinkDealLegReq, QrProductInfoResp, CreateStockMovementDealRollReq, CreateStockMovementDealRollResp, ListNominatedPurchaserDetailsReq, ListNominatedPurchaserDetailsResp, PurchaserCreditLimitDetails, UpdatePurchaserReq, NominatedPurchaserReq, NominatedPurchaserDetailsView, NominatedPurchaserIndexItemView, OrgCustomerSavedDeliveryInfo, NominatedPurchasersForPurchaserReq, NominatedPurchasersForPurchaser, PurchaserPurchaseRequestsReq, PurchaserPurchaseRequestView, PurchaserPurchaseRequestReq, PurchaseRequestBreakdownForPurchaser, OrganisationNominatedPurchaserReq, OrganisationGetPurchaseRequestReq, OrganisationPurchaseRequestsReportReq, OrganisationPurchaseRequestDetailsView, OrganisationPurchaseRequestReq, UpdatePurchaseRequestResp, PurchaseRequestReq, PurchaserAcceptPurchaseRequestReq, PurchaseRequestMarkDateReq, UpdatePurchaseRequestOrganisationPaidReq, UpdatePurchaseRequestPurchaserPaidReq, CreatePurchaseRequestReq, CreatePurchaseRequestResp, EditPurchaseRequestReq, EditPurchaseRequestResp, CancelPurchaseRequestReq, CancelPurchaseRequestResp, GetOutgoingOrdersReq, GetOutgoingOrdersResp, GetUploadUrlReq, GetUploadUrlResp, GetDownloadUrlReq, GetDownloadUrlResp, OrganisationLogoReq, PreviewPurchaseRequestTimelineReq, ThirdPartySalesSummaryResp, ThirdPartySalesSummaryByDateReq, PurchaseRequestPreviewReq, ThirdPartySalesSummaryPreviewResp, AmendPurchaseRequestPreviewReq, PurchaseRequestFinishableProductsReq, FinishableProductListing, GetProductionOptionsForFinishedProductsMapReq, GetProductionOptionsForFinishedProductsMapResp, OrganisationProductCodesReq, OrganisationProductResp, StorageLocTopLevelUnitTypeReq, StockAdjustment, CreateNegativeStockAdjustmentReq, CreateNegativeStockAdjustmentResp, PreviewNegativeStockAdjustmentSalesReq, PreviewNegativeStockAdjustmentSalesResp, NegativeStockAdjustmentDetailsViewReq, NegativeStockAdjustmentDetailsViewResp, StorageLocationSearchReq, StorageLocationProductHolding, CreatePositiveStockAdjustmentResp, PositiveStockAdjustmentReq, PositiveStockAdjustmentDetailsView, GenerateSupplierActionLinkReq, GenerateSupplierActionLinkResp, GeneratePurchaserActionLinkReq, GeneratePurchaserActionLinkResp, GetOrganisationCreditLimitsResp, ThirdPartySalePaymentToMake, ExistingStockProcurementPaymentToMake, NewStockProcurementPaymentToMake, GetUpdatedFinalFxAmountToPayReq, OrganisationExpiringStockView, OrganisationRepurchaseExpiringStockViewResp, OrganisationExpiringStockRollRequest, OrganisationExpiringStockRollRequestResp, OrganisationDealRenewalsRequestedStock, DealExtensionRequestDetailsReq, OrganisationDealExtensionRequestDetailsView, OrganisationProgressDealExtensionRequestReq, OrganisationProgressDealExtensionRequestResp, MinimalDealExtensionRequestView, OrganisationImportantReminders, ProductDutyReq, ProductDutyResp, WorkflowCreationReq, WorkflowResp, WorkflowTransitionReq, ContractNoteFetchReq, ContractNoteFetchResp, ContractNotePreviewReq, ContractNotePreviewResp, ContractNoteSourceRequest, OrgWfQuery, RevaluationRequestSummary, RevaluationDetailsResp, ProgressRevaluationRequestReq, ProgressRevaluationRequestResp, PresetSalePricesUploadReq, PresetSalePricesReq, ProductSalePriceInfo, OrgProductLookupReq, OrgGetProductReq, NomPurchaserStorefrontConfigData, StorefrontProductAllocationData, SaveStorefrontConfigsReq, OrgSetStorefrontEnablementReq, StorefrontConfigResp, StorefrontProductsResp, StorefrontOrder, SubmitStorefrontOrderReq, SubmitStorefrontOrderResp, TokenStatus, TradeSaleAccountingEventReq, NewDealRequestStateChangeAccountingEventReq, TestInternalApiReq, DashboardDataReq, DashboardSalesResp, DashboardExpiringDealsResp, DashboardStockBalancesResp } from "./ferovinum/app/api";
import { Unit, Paginated, BigDecimal } from "./common";
import { PurchaserId, StorageLocation, OrganisationDeliveryLocation, SaleOrderId, NewDealRequestId, Carrier, NominatedPurchaserTerms, TopLevelUnitType, DealLeg, SaleOrder, FinishingService, Product, Supplier, SupplierId, PurchaseRequestId, RatesCurve, TrueLayerProvider, VisionEndpoint, SavedDeliveryInfo, PurchaseRequest, OrganisationId, InvoiceId, StorageLocationLcbHeldOrders, ContractNote, RevaluationRequestId, NumberOfUnits, NominatedPurchaserId, DeliveryFee, StorageLocationId } from "./ferovinum/app/db";
import { Map, Set, Maybe } from "./sys/types";
import { WithDbId, DbKey } from "./common/db";
import { CSVData, OrganisationAvailableStockViewCSV, PurchasedStockView, PurchasedStockCSV, SoldStockView, SoldStockCSV, CapitalisedExpensesView, CapitalisedExpensesCSV, ProductMovementReport, ContractNoteView } from "./ferovinum/app/views";
import { SupplierPOView, NewDealRequestView, NewDealRequestCarrierView, NewDealRequestOrganisationView } from "./ferovinum/app/procurement";
import { ReportReq, ReportResp } from "./ferovinum/app/reporting";
import { PurchaseRequestTimeline } from "./ferovinum/app/nompurchaser";
import { StringNE } from "./common/strings";
import { CreatePositiveStockAdjustmentReq, Workflow } from "./ferovinum/app/workflow";
import { SettlementCreditDetailsReq, SettlementCreditDetailsResp, CreateOrUpdateSettlementCreditReq, CreateOrUpdateSettlementCreditResp } from "./ferovinum/app/settlementcredit";
import { HttpServiceError } from "adl-service/http-service-error";
// @ts-ignore - Ignore unused imports typescript error
import { GetFn, PostFn } from "adl-service/types";
import { HttpFetch, HttpHeaders } from "utils/hx/service/http";

import { DeclResolver } from "./runtime/adl";
import {AdlHttpServiceBase} from "adl-service/adl-http-service-base";

/** Ferovinium API */
export class AppService extends AdlHttpServiceBase {
  /** Login a user */
  postLogin: PostFn<LoginReq, LoginResp>;

  /** Gets the logged in user details */
  getWhoAmI: GetFn<UserProfile>;

  /** Returns the memberships to the various entities that this user has */
  getGetMemberships: GetFn<UserMembership>;

  postLogClientErrorPublic: PostFn<ClientLogReq, Unit>;

  postLogClientErrorUser: PostFn<ClientLogReq, Unit>;

  /** Forgot password */
  postForgotUserPassword: PostFn<UserForgotPasswordReq, Unit>;

  /** Lets a user reset their password */
  postResetUserPasswordAction: PostFn<UserResetPasswordActionReq, Unit>;

  /** Create a list of new purchasers */
  postCreatePurchasers: PostFn<CreatePurchaserAndNomPurchaserReq[], PurchaserId[]>;

  postGetLocationsProductListings: PostFn<LocationsProductListingsReq, Map<WithDbId<StorageLocation>,ProductListing[]>>;

  postGetOrgProductListingsAtLocation: PostFn<OrgLocationProductListingsReq, ProductListing[]>;

  postGetThirdPartySaleFinishedProductListings: PostFn<LocationsProductListingsReq, Map<WithDbId<StorageLocation>,ThirdPartySaleFinishedProductListing[]>>;

  postGetThirdPartySaleFinishableProductListings: PostFn<LocationsProductListingsReq, Map<WithDbId<StorageLocation>,ThirdPartySaleFinishableProductListing[]>>;

  postGetOrganisationDeliveryLocations: PostFn<OrganisationReq, WithDbId<OrganisationDeliveryLocation>[]>;

  postAckSaleOrder: PostFn<SaleOrderAckReq, SaleOrderId>;

  postCancelSaleOrder: PostFn<SaleOrderCancelReq, SaleOrderId>;

  postCreateSaleOrder: PostFn<SaleOrderCreateReq, SaleOrderCreateResp>;

  postCreateOrUpdateNewStockNewDealRequest: PostFn<NewStockNewDealReq, NewDealRequestId>;

  postCreateOrUpdateExistingStockNewDealRequest: PostFn<ExistingStockNewDealReq, NewDealRequestId>;

  postReleaseSaleOrder: PostFn<SaleOrderReleaseReq, SaleOrderId>;

  postGetSaleOrder: PostFn<SaleOrderGetReq, SaleOrderDetailsView>;

  postGetProductionOrder: PostFn<ProductionOrderReq, ProductionOrderDetailsView>;

  postGetDealLegRepurchaseOrder: PostFn<DealLegRepurchaseOrderReq, DealLegRepurchaseOrderPreview>;

  postGetSaleOrderPreview: PostFn<SaleOrderPreviewReq, SaleOrderPreview>;

  postGetStorageLocations: PostFn<GetStorageLocationsReq, StorageLocationView[]>;

  postGetCarriers: PostFn<GetCarrierReq, WithDbId<Carrier>[]>;

  postGetOrgExistingProducts: PostFn<OrgExistingProductsReq, ExistingProductsResp>;

  getGetAllNominatedPurchaserTerms: GetFn<WithDbId<NominatedPurchaserTerms>[]>;

  postGetStockData: PostFn<StockDataReq, StockListing[]>;

  postGetStockTopLevelUnitTypes: PostFn<OrganisationReq, Set<TopLevelUnitType>>;

  postGetStockDataCounts: PostFn<OrganisationReq, Map<TopLevelUnitType,StockDataCounts>>;

  postGetStock: PostFn<GetAvailableStockReq, DetailedPhysicalStock[]>;

  postGetProductBalances: PostFn<ProductBalancesReq, Map<TopLevelUnitType,ProductBalance[]>>;

  /** returns a breakdown list of reserved for production units for a specific product */
  postGetProductReservationsAtLoc: PostFn<ProductReservationsReq, ProductReservationsResp>;

  postGetProductTypeBalancesCsv: PostFn<StorageLocProductBalanceCSVReq, CSVData<string>>;

  postGetOrganisationAvailableStockCsv: PostFn<OrganisationAvailableStockReq, OrganisationAvailableStockViewCSV>;

  postGetFspByDate: PostFn<DealLegFspRequest, Map<DbKey<DealLeg>,CalculatedFsp>>;

  postGetFspDetailsForDate: PostFn<DealLegFspRequest, Map<DbKey<DealLeg>,CalculatedFspDetails>>;

  postGetRepurchaseSaleOrders: PostFn<OrganisationReq, WithDbId<SaleOrder>[]>;

  postGetLossSaleOrders: PostFn<OrganisationReq, WithDbId<SaleOrder>[]>;

  getOutstandingInvoiceList: GetFn<InvoiceListItem[]>;

  postPreviewProductionOrderTotals: PostFn<PreviewProductionOrderTotalsReq, ProductionOrderTotals>;

  postCreateProductionOrder: PostFn<ProductionOrderCreateReq, ProductionOrderCreateResp>;

  postAcceptProductionOrder: PostFn<ProductionOrderReq, Unit>;

  postCompleteProductionOrderTask: PostFn<CreateProductionOrderTaskRunReq, CreateProductionOrderTaskRunResp>;

  postCancelProductionOrder: PostFn<ProductionOrderReq, Unit>;

  postRejectProductionOrder: PostFn<RejectProductionOrderReq, Unit>;

  postGetOrganisationProductionOrders: PostFn<OrganisationReq, ProductionOrderListingView[]>;

  postGetStorageLocationProductionOrders: PostFn<StorageLocationReq, ProductionOrderListingView[]>;

  postGetProductFinishingServices: PostFn<SourceProductProductionServicesReq, Map<WithDbId<FinishingService>,WithDbId<Product>[]>>;

  postGetProductToFinishingServicesMap: PostFn<FinishingServicesByOrgAndStorageLocReq, Map<DbKey<Product>,WithDbId<FinishingService>[]>>;

  postProductSearch: PostFn<ProductSearchQueryReq, WithDbId<Product>[]>;

  postProductDealLegSearch: PostFn<ProductDealLegSearchQueryReq, WithDbId<Product>[]>;

  postSupplierSearch: PostFn<SearchQueryReq, WithDbId<Supplier>[]>;

  postGetOrgSupplier: PostFn<SupplierId, WithDbId<Supplier>>;

  postSupplierPurchaseOrders: PostFn<SupplierPurchaseOrdersListingReq, Paginated<SupplierPOView>>;

  postSupplierAcceptNewDealRequest: PostFn<SupplierAcceptNewDealRequestReq, SupplierNewDealRequestActionResp>;

  postSupplierUpdateNewDealRequest: PostFn<SupplierUpdateNewDealRequestReq, SupplierNewDealRequestActionResp>;

  postGetNewDealRequests: PostFn<NewDealRequestQueryReq, Paginated<NewDealRequestQueryResp>>;

  getGetOverdueNewDealRequests: GetFn<NewDealRequestView[]>;

  postGetPurchaseRequestsForAdmin: PostFn<AdminGetPurchaseRequestReq, PurchaseRequestView[]>;

  postGetPurchaseRequestForAdmin: PostFn<PurchaseRequestId, AdminPurchaseRequestDetailsView>;

  postGetNewDealRequestDetails: PostFn<NewDealRequestDetailsReq, NewDealRequestView>;

  postGetStorageLocNewDealRequestShipments: PostFn<StorageLocNewDealRequestShipmentReq, StorageLocNewDealRequestShipmentResp>;

  postStorageLocConfirmDelivery: PostFn<StorageLocConfirmDeliveryReq, StorageLocConfirmDeliveryResp>;

  postCancelNewDealRequest: PostFn<NewDealRequestId, NewDealRequestCancellationResp>;

  postGetNewDealRequestsForCarrier: PostFn<NewDealRequestsForCarrierReq, Paginated<NewDealRequestCarrierView>>;

  postGetNewDealRequestsForOrganisation: PostFn<NewDealRequestsForOrganisationReq, Paginated<NewDealRequestOrganisationView>>;

  postGetInProgressNewDealRequestsOverview: PostFn<OrganisationReq, InProgressNewDealRequestOverview[]>;

  postCarrierAdvanceNewDeal: PostFn<CarrierAdvanceNewDealReq, CarrierAdvanceNewDealResp>;

  postPreviewNewDealRequestLineItems: PostFn<PreviewNewDealRequestProductLineItemsReq, PreviewNewDealRequestProductLineItemsResp>;

  /** Returns a valuation preview for an organisation while setting up a new [new deal request] */
  postOrganisationPreviewNewDealRequest: PostFn<OrganisationPreviewNewDealRequestReq, OrganisationPreviewNewDealRequestResp>;

  /** Ferovinum HQ confirms a new deal request by setting the deal terms */
  postConfirmNewStockNewDealRequest: PostFn<ConfirmNewDealRequestReq, ConfirmNewDealRequestResp>;

  postConfirmExistingStockNewDealRequest: PostFn<ConfirmExistingStockNewDealRequestReq, ConfirmExistingStockNewDealRequestResp>;

  postConfirmExistingStockNewDealRequestStockOwnershipTransfer: PostFn<StockOwnershipTransferConfirmationReq, StockOwnershipTransferConfirmationRequestResp>;

  postConfirmExistingStockNewDealRequestPaymentTransfer: PostFn<PaymentTransferConfirmationReq, PaymentTransferConfirmationRequestResp>;

  /** Ferovinum HQ rejects a new deal request */
  postRejectNewDealRequest: PostFn<RejectNewDealRequestReq, RejectNewDealRequestResp>;

  /** Ferovinum HQ voids a new deal request */
  postVoidNewDealRequest: PostFn<VoidNewDealReq, VoidNewDealResp>;

  /** Ferovinum HQ confirms that a payment attached to the new deal request has been paid (deposit payment, supplier payment or carrier payment) */
  postConfirmPaymentNewDealRequest: PostFn<ConfirmPaymentNewDealRequestReq, ConfirmPaymentNewDealRequestResp>;

  /** Ferovinum HQ confirms that a supplier payment */
  postConfirmSupplierPaymentNewDealRequest: PostFn<ConfirmSupplierPaymentNewDealRequestReq, ConfirmPaymentNewDealRequestResp>;

  /** Organisation advances a new deal request state */
  postOrganisationAdvanceNewStockNewDealRequest: PostFn<OrganisationAdvanceNewStockNewDealRequestReq, OrganisationAdvanceNewDealRequestResp>;

  postOrganisationAdvanceExistingStockNewDealRequest: PostFn<OrganisationAdvanceExistingStockNewDealRequestReq, OrganisationAdvanceNewDealRequestResp>;

  /** Organisation inventory view */
  postGetOrganisationInventory: PostFn<OrganisationStockReq, Paginated<OrganisationProductInventoryView>>;

  /** Organisation inventory view by product ids */
  postGetOrganisationInventoryByProductIds: PostFn<OrganisationStockByProductIdsReq, OrganisationProductInventoryView[]>;

  /** Check if a product code already exists within an organisation */
  postCheckIfProductCodeExists: PostFn<CheckProductCodeReq, boolean>;

  /** Fetch a product based on the given product id */
  postGetProducts: PostFn<GetProductReq, GetProductResp>;

  /** get a list of rates curves available (used to calculate monthly fees) */
  getGetAllRatesCurves: GetFn<WithDbId<RatesCurve>[]>;

  getCheckRestateAuth: GetFn<string>;

  postGetRatesCurve: PostFn<GetRatesCurveReq, GetRatesCurveResp>;

  postUpdateRatesCurve: PostFn<UpdateRatesCurveReq, UpdateRatesCurveResp>;

  /** View purchased stock (JSON - user token) */
  getViewPurchasedStock: GetFn<PurchasedStockView[]>;

  /** View purchased stock (CSV - user token) */
  getViewPurchasedStockCsv: GetFn<PurchasedStockCSV>;

  /** View sold stock (JSON - user token) */
  getViewSoldStock: GetFn<SoldStockView[]>;

  /** View sold stock (CSV - user token) */
  getViewSoldStockCsv: GetFn<SoldStockCSV>;

  /** View capitalised expenses (JSON - user token) */
  getViewCapitalisedExpenses: GetFn<CapitalisedExpensesView[]>;

  /** View capitalised expenses (CSV - user token) */
  getViewCapitalisedExpensesCsv: GetFn<CapitalisedExpensesCSV>;

  postPreviewCapitalisedExpense: PostFn<CreateCapitalisedExpenseReq, PreviewCapitalisedExpenseResp>;

  postCreateCapitalisedExpense: PostFn<CreateCapitalisedExpenseReq, CreateCapitalisedExpenseResp>;

  /** TrueLayer API OAuth */
  postTrueLayerAuthorisation: PostFn<TrueLayerProvider, string>;

  getTrueLayerCallback: GetFn<Unit>;

  /** Vision API connection authorisation */
  postVisionAuthorisation: PostFn<VisionEndpoint, string>;

  postProductMovementReport: PostFn<ProductMovementReportReq, Maybe<ProductMovementReport>>;

  postReportingEval: PostFn<ReportReq, ReportResp>;

  postReportingAsyncRequest: PostFn<ReportReq, string>;

  postReportingAsyncResponse: PostFn<string, (ReportResp|null)>;

  postQrGenerateCode: PostFn<Unit, QrGenerateCodeResp>;

  postQrLinkDealLeg: PostFn<QrLinkDealLegReq, boolean>;

  postQrProductInfo: PostFn<string, (QrProductInfoResp|null)>;

  postCreateStockMovementDealRoll: PostFn<CreateStockMovementDealRollReq, CreateStockMovementDealRollResp>;

  postListNominatedPurchasers: PostFn<ListNominatedPurchaserDetailsReq, ListNominatedPurchaserDetailsResp>;

  getListPurchaserCreditLimitDetails: GetFn<PurchaserCreditLimitDetails[]>;

  postUpdatePurchaser: PostFn<UpdatePurchaserReq, Unit>;

  postGetNominatedPurchaserDetailsView: PostFn<NominatedPurchaserReq, (NominatedPurchaserDetailsView|null)>;

  postGetNominatedPurchasersForOrg: PostFn<OrganisationReq, NominatedPurchaserDetailsView[]>;

  postGetNominatedPurchaserIndexItemsForOrg: PostFn<OrganisationReq, NominatedPurchaserIndexItemView[]>;

  postGetNominatedPurchaserOutstandingBalanceSummaryPdf: PostFn<NominatedPurchaserReq, string>;

  postGetNominatedPurchaserSavedDeliveryInfoList: PostFn<NominatedPurchaserReq, SavedDeliveryInfo[]>;

  postGetOrgCustomerSavedDeliveryInfoList: PostFn<OrganisationReq, OrgCustomerSavedDeliveryInfo[]>;

  postGetNominatedPurchasersForPurchaser: PostFn<NominatedPurchasersForPurchaserReq, NominatedPurchasersForPurchaser[]>;

  postGetPurchaseRequestsForPurchaser: PostFn<PurchaserPurchaseRequestsReq, PurchaserPurchaseRequestView[]>;

  postGetPurchaseRequestBreakdownForPurchaser: PostFn<PurchaserPurchaseRequestReq, PurchaseRequestBreakdownForPurchaser>;

  postGetNominatedPurchaserPurchaseRequests: PostFn<OrganisationNominatedPurchaserReq, WithDbId<PurchaseRequest>[]>;

  postGetPurchaseRequestsForOrganisation: PostFn<OrganisationGetPurchaseRequestReq, PurchaseRequestView[]>;

  postGeneratePurchaseRequestReportForOrgAndSendEmail: PostFn<OrganisationPurchaseRequestsReportReq, OrganisationId>;

  postGetPurchaseRequestDetailsForOrganisation: PostFn<PurchaseRequestId, OrganisationPurchaseRequestDetailsView>;

  postGetPurchaseRequestDetailsForPurchaser: PostFn<PurchaseRequestId, PurchaserPurchaseRequestView>;

  postGetNominatedPurchaserTermsForPurchaser: PostFn<PurchaseRequestId, NominatedPurchaserTerms>;

  postOrganisationMarkPurchaseRequestReadyForCollection: PostFn<OrganisationPurchaseRequestReq, UpdatePurchaseRequestResp>;

  postPurchaserRejectPurchaseRequest: PostFn<PurchaseRequestReq, UpdatePurchaseRequestResp>;

  postPurchaserAcceptPurchaseRequest: PostFn<PurchaserAcceptPurchaseRequestReq, UpdatePurchaseRequestResp>;

  postMarkPurchaseRequestCollected: PostFn<PurchaseRequestMarkDateReq, UpdatePurchaseRequestResp>;

  postMarkPurchaseRequestDelivered: PostFn<PurchaseRequestMarkDateReq, UpdatePurchaseRequestResp>;

  postAdminMarkPurchaseRequestOrganisationPaid: PostFn<UpdatePurchaseRequestOrganisationPaidReq, UpdatePurchaseRequestResp>;

  postAdminMarkPurchaseRequestPurchaserPaid: PostFn<UpdatePurchaseRequestPurchaserPaidReq, UpdatePurchaseRequestResp>;

  postCreatePurchaseRequest: PostFn<CreatePurchaseRequestReq, CreatePurchaseRequestResp>;

  postEditPurchaseRequest: PostFn<EditPurchaseRequestReq, EditPurchaseRequestResp>;

  postCancelPurchaseRequest: PostFn<CancelPurchaseRequestReq, CancelPurchaseRequestResp>;

  postGetOutgoingOrdersForStorageLocation: PostFn<GetOutgoingOrdersReq, GetOutgoingOrdersResp>;

  postGetUploadUrl: PostFn<GetUploadUrlReq, GetUploadUrlResp>;

  postGetPublicAssetUploadUrl: PostFn<GetUploadUrlReq, GetUploadUrlResp>;

  postGetDownloadUrl: PostFn<GetDownloadUrlReq, GetDownloadUrlResp>;

  postGenerateInvoicePdf: PostFn<InvoiceId, string>;

  postAddLogoToOrganisation: PostFn<OrganisationLogoReq, Unit>;

  postGetPurchaseRequestTimeline: PostFn<PurchaseRequestId, PurchaseRequestTimeline>;

  postGetPurchaseRequestTimelinePreview: PostFn<PreviewPurchaseRequestTimelineReq, PurchaseRequestTimeline>;

  postThirdPartySalesSummaryById: PostFn<PurchaseRequestId, ThirdPartySalesSummaryResp>;

  postThirdPartySalesSummaryByDate: PostFn<ThirdPartySalesSummaryByDateReq, ThirdPartySalesSummaryResp>;

  postThirdPartySalesSummaryPreview: PostFn<PurchaseRequestPreviewReq, ThirdPartySalesSummaryPreviewResp>;

  postAmendTradeSaleSummaryPreview: PostFn<AmendPurchaseRequestPreviewReq, ThirdPartySalesSummaryPreviewResp>;

  /** Returns a list of finished products that can be added to a purchase request through a production order of the given source products for a given organisation and storage location */
  postGetPurchaseRequestFinishableProducts: PostFn<PurchaseRequestFinishableProductsReq, FinishableProductListing[]>;

  /** Returns a map of production options, i.e. source product and finishing service that can be used to generate the specified finisable product */
  postGetProductionOptionsForFinishedProducts: PostFn<GetProductionOptionsForFinishedProductsMapReq, GetProductionOptionsForFinishedProductsMapResp>;

  postGetProductCodeToProductMap: PostFn<OrganisationProductCodesReq, Map<StringNE,OrganisationProductResp>>;

  postGetStorageLocationStockAdjustments: PostFn<StorageLocTopLevelUnitTypeReq, Map<TopLevelUnitType,StockAdjustment[]>>;

  postCreateNegativeStockAdjustment: PostFn<CreateNegativeStockAdjustmentReq, CreateNegativeStockAdjustmentResp>;

  postPreviewNegativeStockAdjustment: PostFn<PreviewNegativeStockAdjustmentSalesReq, PreviewNegativeStockAdjustmentSalesResp>;

  postGetNegativeStockAdjustmentDetails: PostFn<NegativeStockAdjustmentDetailsViewReq, NegativeStockAdjustmentDetailsViewResp>;

  postGetStorageLocationProductHoldings: PostFn<StorageLocationSearchReq, Map<TopLevelUnitType,Map<WithDbId<Product>,StorageLocationProductHolding[]>>>;

  postCreatePositiveStockAdjustment: PostFn<CreatePositiveStockAdjustmentReq, CreatePositiveStockAdjustmentResp>;

  postGetPositiveStockAdjustmentDetails: PostFn<PositiveStockAdjustmentReq, PositiveStockAdjustmentDetailsView>;

  getGetLcbHeldOrders: GetFn<Map<string,StorageLocationLcbHeldOrders>>;

  postActionLinkSupplierPurchaseOrders: PostFn<SupplierPurchaseOrdersListingReq, SupplierPOView>;

  postActionLinkSupplierAcceptNewDealRequest: PostFn<SupplierAcceptNewDealRequestReq, SupplierNewDealRequestActionResp>;

  /** Purchaser Action Link Endpoints */
  postActionLinkGetPurchaseRequestBreakdownForPurchaser: PostFn<PurchaserPurchaseRequestReq, PurchaseRequestBreakdownForPurchaser>;

  postActionLinkGetNominatedPurchaserTermsForPurchaser: PostFn<PurchaseRequestId, NominatedPurchaserTerms>;

  postActionLinkGetPurchaseRequestDetailsForPurchaser: PostFn<PurchaseRequestId, PurchaserPurchaseRequestView>;

  postActionLinkPurchaserRejectPurchaseRequest: PostFn<PurchaseRequestReq, UpdatePurchaseRequestResp>;

  postActionLinkPurchaserAcceptPurchaseRequest: PostFn<PurchaserAcceptPurchaseRequestReq, UpdatePurchaseRequestResp>;

  postActionLinkGetPurchaserPurchaseRequestTimeline: PostFn<PurchaseRequestId, PurchaseRequestTimeline>;

  postConfirmTradeSalesOrderAuthorizationLink: PostFn<Unit, Unit>;

  /** END of Purchaser Action Link Endpoints Get accept new deal request action url for test purposes */
  postGenerateSupplierActionLinkParams: PostFn<GenerateSupplierActionLinkReq, GenerateSupplierActionLinkResp>;

  /** Get accept purchase request action url for test purposes */
  postGeneratePurchaserActionLinkParams: PostFn<GeneratePurchaserActionLinkReq, GeneratePurchaserActionLinkResp>;

  /** Generates a email to the nominated purchaser with a link to accept the org to make orders on their behalf This will resend all the emails to the nominated purchasers for the given purchaser */
  postSendTradeSalesOrderAuthorizationForOrg: PostFn<OrganisationId, Unit>;

  /** Returns a summary of the credit limits for each organisation. Should only be able to be called by an admin */
  getGetOrganisationCreditLimits: GetFn<GetOrganisationCreditLimitsResp>;

  getGetThirdPartySalePaymentsToMake: GetFn<ThirdPartySalePaymentToMake[]>;

  getGetExistingStockProcurementPaymentsToMake: GetFn<ExistingStockProcurementPaymentToMake[]>;

  getGetNewStockProcurementPaymentsToMake: GetFn<NewStockProcurementPaymentToMake[]>;

  postGetUpdatedThirdPartySaleFinalFxAmountToPay: PostFn<GetUpdatedFinalFxAmountToPayReq, BigDecimal>;

  /** Gets deal leg for an organisation that will expire within 30 days and that the org has not made any decision about */
  postGetDecisionRequiredOrganisationExpiringStockViews: PostFn<OrganisationReq, OrganisationExpiringStockView[]>;

  /** Gets deal legs for an organisation that: - Will expire within 30 days and the org is intending to repurchase some or all units - Will expire within 30 days and Fero has rejected the expiry roll intention - Have already expired but before the overdue deadline */
  postGetOrganisationExpiringStockViewsToBeRepurchased: PostFn<OrganisationReq, OrganisationRepurchaseExpiringStockViewResp>;

  /** Sets the deal legs' expiry roll intention to the requested number of units to roll */
  postRequestToRollExpiringStock: PostFn<OrganisationExpiringStockRollRequest, OrganisationExpiringStockRollRequestResp>;

  /** Gets expiring stock that the org has sent a renewal request for. The returned objects can either be deal legs pending review from Ferovinum or it can be deal extension requests for those that have already been reviewed. */
  postGetOrganisationDealRenewalsRequestedStock: PostFn<OrganisationReq, OrganisationDealRenewalsRequestedStock>;

  postGetOrganisationDealExtensionRequestDetails: PostFn<DealExtensionRequestDetailsReq, OrganisationDealExtensionRequestDetailsView>;

  /** Allows a user to progress the state of a deal extension request. The actions available for orgs are: accept terms, reject terms, mark invoice as paid */
  postProgressDealExtensionRequestState: PostFn<OrganisationProgressDealExtensionRequestReq, OrganisationProgressDealExtensionRequestResp>;

  postGetOrganisationCompletedDealExtensionRequests: PostFn<OrganisationReq, MinimalDealExtensionRequestView[]>;

  /** Returns important reminders to be displayed for org users */
  postGetOrganisationImportantReminders: PostFn<OrganisationReq, OrganisationImportantReminders>;

  /** Returns the duty for the supplied product quantities */
  postGetDutyForProductQuantities: PostFn<ProductDutyReq, ProductDutyResp>;

  /** Create new workflow with workflow actions. Only actions that are accepted by WorkflowController::handleStateCreation are valid. */
  postCreateWorkflow: PostFn<WorkflowCreationReq, WorkflowResp>;

  postTransitionWorkflow: PostFn<WorkflowTransitionReq, WorkflowResp>;

  postGetContractNote: PostFn<ContractNoteFetchReq, ContractNoteFetchResp>;

  postGetContractNoteView: PostFn<ContractNoteFetchReq, ContractNoteView>;

  postPreviewContractNote: PostFn<ContractNotePreviewReq, ContractNotePreviewResp>;

  postCreateContractNote: PostFn<ContractNoteSourceRequest, DbKey<ContractNote>>;

  postOrgWfQuery: PostFn<OrgWfQuery, WithDbId<Workflow>[]>;

  /** Returns a list of revaluation requests associated with the organisation */
  postRevaluationRequestOverview: PostFn<OrganisationId, RevaluationRequestSummary[]>;

  /** Returns details of a revaluation request */
  postRevaluationDetails: PostFn<RevaluationRequestId, RevaluationDetailsResp>;

  /** Allows org to progress the revaluation request state (accepted and rejected from created) */
  postProgressRevaluationRequestState: PostFn<ProgressRevaluationRequestReq, ProgressRevaluationRequestResp>;

  postSaveProductSalePrices: PostFn<PresetSalePricesUploadReq, Unit>;

  postGetProductSalePrices: PostFn<PresetSalePricesReq, ProductSalePriceInfo[]>;

  postOrgLookupProducts: PostFn<OrgProductLookupReq, DbKey<Product>[]>;

  postOrgGetProductQuantitiesAvailableToSell: PostFn<OrgGetProductReq, Map<DbKey<Product>,NumberOfUnits>>;

  postOrgGetStoreConfigs: PostFn<OrganisationId, NomPurchaserStorefrontConfigData[]>;

  postOrgGetStoreAllocationsForNomPurchaser: PostFn<NominatedPurchaserId, StorefrontProductAllocationData[]>;

  postOrgSaveStorefrontConfigForNominatedPurchasers: PostFn<SaveStorefrontConfigsReq, Unit>;

  postOrgSetStorefrontEnablement: PostFn<OrgSetStorefrontEnablementReq, Unit>;

  postBuyerGetStorefrontConfig: PostFn<NominatedPurchaserId, StorefrontConfigResp>;

  postBuyerGetStorefrontProducts: PostFn<NominatedPurchaserId, StorefrontProductsResp>;

  postBuyerGetStorefrontSavedDeliveryDetails: PostFn<NominatedPurchaserId, SavedDeliveryInfo[]>;

  postBuyerEstimateDeliveryFees: PostFn<StorefrontOrder, DeliveryFee>;

  postStorageLocationSupportsDeliveryCalculation: PostFn<StorageLocationId, boolean>;

  postBuyerSubmitStorefrontOrder: PostFn<SubmitStorefrontOrderReq, SubmitStorefrontOrderResp>;

  postSettlementCreditDetails: PostFn<SettlementCreditDetailsReq, SettlementCreditDetailsResp>;

  postCreateOrUpdateCreditLimit: PostFn<CreateOrUpdateSettlementCreditReq, CreateOrUpdateSettlementCreditResp>;

  postVerifyAdminAccessToken: PostFn<Unit, TokenStatus>;

  postTriggerRepurchaseStockAccountingEvent: PostFn<SaleOrderId[], Unit>;

  postTriggerTradeSaleStateChangeAccountingEvent: PostFn<TradeSaleAccountingEventReq[], Unit>;

  postTriggerNewDealReqStateChangeAccountingEvent: PostFn<NewDealRequestStateChangeAccountingEventReq[], Unit>;

  postProcessUnmatchedInvoices: PostFn<string[], Unit>;

  postTestInternalApi: PostFn<TestInternalApiReq, Unit>;

  postGetDashboardSalesData: PostFn<DashboardDataReq, DashboardSalesResp[]>;

  postGetDashboardExpiringDeals: PostFn<DashboardDataReq, DashboardExpiringDealsResp[]>;

  postGetDashboardStockBalances: PostFn<DashboardDataReq, DashboardStockBalancesResp[]>;

  constructor(
    /** Fetcher over HTTP */
    http: HttpFetch,
    /** Base URL of the API endpoints */
    baseUrl: string,
    /** Resolver for ADL types */
    resolver: DeclResolver,
    /** The authentication token (if any) */
    authToken: string | undefined,
    /** Error handler to allow for cross cutting concerns, e.g. authorization errors */
    handleError: (error: HttpServiceError) => void,
    handleHeaders: (headers: HttpHeaders) => void,
    /** Optional domain parameter Eg. api.dev.ferovinum.link */
    domain?: string
  ) {
    super(http, baseUrl, resolver, authToken, handleError, handleHeaders, domain);
    const api = this.annotatedApi(snApiRequests, makeApiRequests({}));
    this.postLogin = this.mkPostFn(api.login);
    this.getWhoAmI = this.mkGetFn(api.whoAmI);
    this.getGetMemberships = this.mkGetFn(api.getMemberships);
    this.postLogClientErrorPublic = this.mkPostFn(api.logClientErrorPublic);
    this.postLogClientErrorUser = this.mkPostFn(api.logClientErrorUser);
    this.postForgotUserPassword = this.mkPostFn(api.forgotUserPassword);
    this.postResetUserPasswordAction = this.mkPostFn(api.resetUserPasswordAction);
    this.postCreatePurchasers = this.mkPostFn(api.createPurchasers);
    this.postGetLocationsProductListings = this.mkPostFn(api.getLocationsProductListings);
    this.postGetOrgProductListingsAtLocation = this.mkPostFn(api.getOrgProductListingsAtLocation);
    this.postGetThirdPartySaleFinishedProductListings = this.mkPostFn(api.getThirdPartySaleFinishedProductListings);
    this.postGetThirdPartySaleFinishableProductListings = this.mkPostFn(api.getThirdPartySaleFinishableProductListings);
    this.postGetOrganisationDeliveryLocations = this.mkPostFn(api.getOrganisationDeliveryLocations);
    this.postAckSaleOrder = this.mkPostFn(api.ackSaleOrder);
    this.postCancelSaleOrder = this.mkPostFn(api.cancelSaleOrder);
    this.postCreateSaleOrder = this.mkPostFn(api.createSaleOrder);
    this.postCreateOrUpdateNewStockNewDealRequest = this.mkPostFn(api.createOrUpdateNewStockNewDealRequest);
    this.postCreateOrUpdateExistingStockNewDealRequest = this.mkPostFn(api.createOrUpdateExistingStockNewDealRequest);
    this.postReleaseSaleOrder = this.mkPostFn(api.releaseSaleOrder);
    this.postGetSaleOrder = this.mkPostFn(api.getSaleOrder);
    this.postGetProductionOrder = this.mkPostFn(api.getProductionOrder);
    this.postGetDealLegRepurchaseOrder = this.mkPostFn(api.getDealLegRepurchaseOrder);
    this.postGetSaleOrderPreview = this.mkPostFn(api.getSaleOrderPreview);
    this.postGetStorageLocations = this.mkPostFn(api.getStorageLocations);
    this.postGetCarriers = this.mkPostFn(api.getCarriers);
    this.postGetOrgExistingProducts = this.mkPostFn(api.getOrgExistingProducts);
    this.getGetAllNominatedPurchaserTerms = this.mkGetFn(api.getAllNominatedPurchaserTerms);
    this.postGetStockData = this.mkPostFn(api.getStockData);
    this.postGetStockTopLevelUnitTypes = this.mkPostFn(api.getStockTopLevelUnitTypes);
    this.postGetStockDataCounts = this.mkPostFn(api.getStockDataCounts);
    this.postGetStock = this.mkPostFn(api.getStock);
    this.postGetProductBalances = this.mkPostFn(api.getProductBalances);
    this.postGetProductReservationsAtLoc = this.mkPostFn(api.getProductReservationsAtLoc);
    this.postGetProductTypeBalancesCsv = this.mkPostFn(api.getProductTypeBalancesCSV);
    this.postGetOrganisationAvailableStockCsv = this.mkPostFn(api.getOrganisationAvailableStockCSV);
    this.postGetFspByDate = this.mkPostFn(api.getFspByDate);
    this.postGetFspDetailsForDate = this.mkPostFn(api.getFspDetailsForDate);
    this.postGetRepurchaseSaleOrders = this.mkPostFn(api.getRepurchaseSaleOrders);
    this.postGetLossSaleOrders = this.mkPostFn(api.getLossSaleOrders);
    this.getOutstandingInvoiceList = this.mkGetFn(api.outstandingInvoiceList);
    this.postPreviewProductionOrderTotals = this.mkPostFn(api.previewProductionOrderTotals);
    this.postCreateProductionOrder = this.mkPostFn(api.createProductionOrder);
    this.postAcceptProductionOrder = this.mkPostFn(api.acceptProductionOrder);
    this.postCompleteProductionOrderTask = this.mkPostFn(api.completeProductionOrderTask);
    this.postCancelProductionOrder = this.mkPostFn(api.cancelProductionOrder);
    this.postRejectProductionOrder = this.mkPostFn(api.rejectProductionOrder);
    this.postGetOrganisationProductionOrders = this.mkPostFn(api.getOrganisationProductionOrders);
    this.postGetStorageLocationProductionOrders = this.mkPostFn(api.getStorageLocationProductionOrders);
    this.postGetProductFinishingServices = this.mkPostFn(api.getProductFinishingServices);
    this.postGetProductToFinishingServicesMap = this.mkPostFn(api.getProductToFinishingServicesMap);
    this.postProductSearch = this.mkPostFn(api.productSearch);
    this.postProductDealLegSearch = this.mkPostFn(api.productDealLegSearch);
    this.postSupplierSearch = this.mkPostFn(api.supplierSearch);
    this.postGetOrgSupplier = this.mkPostFn(api.getOrgSupplier);
    this.postSupplierPurchaseOrders = this.mkPostFn(api.supplierPurchaseOrders);
    this.postSupplierAcceptNewDealRequest = this.mkPostFn(api.supplierAcceptNewDealRequest);
    this.postSupplierUpdateNewDealRequest = this.mkPostFn(api.supplierUpdateNewDealRequest);
    this.postGetNewDealRequests = this.mkPostFn(api.getNewDealRequests);
    this.getGetOverdueNewDealRequests = this.mkGetFn(api.getOverdueNewDealRequests);
    this.postGetPurchaseRequestsForAdmin = this.mkPostFn(api.getPurchaseRequestsForAdmin);
    this.postGetPurchaseRequestForAdmin = this.mkPostFn(api.getPurchaseRequestForAdmin);
    this.postGetNewDealRequestDetails = this.mkPostFn(api.getNewDealRequestDetails);
    this.postGetStorageLocNewDealRequestShipments = this.mkPostFn(api.getStorageLocNewDealRequestShipments);
    this.postStorageLocConfirmDelivery = this.mkPostFn(api.storageLocConfirmDelivery);
    this.postCancelNewDealRequest = this.mkPostFn(api.cancelNewDealRequest);
    this.postGetNewDealRequestsForCarrier = this.mkPostFn(api.getNewDealRequestsForCarrier);
    this.postGetNewDealRequestsForOrganisation = this.mkPostFn(api.getNewDealRequestsForOrganisation);
    this.postGetInProgressNewDealRequestsOverview = this.mkPostFn(api.getInProgressNewDealRequestsOverview);
    this.postCarrierAdvanceNewDeal = this.mkPostFn(api.carrierAdvanceNewDeal);
    this.postPreviewNewDealRequestLineItems = this.mkPostFn(api.previewNewDealRequestLineItems);
    this.postOrganisationPreviewNewDealRequest = this.mkPostFn(api.organisationPreviewNewDealRequest);
    this.postConfirmNewStockNewDealRequest = this.mkPostFn(api.confirmNewStockNewDealRequest);
    this.postConfirmExistingStockNewDealRequest = this.mkPostFn(api.confirmExistingStockNewDealRequest);
    this.postConfirmExistingStockNewDealRequestStockOwnershipTransfer = this.mkPostFn(api.confirmExistingStockNewDealRequestStockOwnershipTransfer);
    this.postConfirmExistingStockNewDealRequestPaymentTransfer = this.mkPostFn(api.confirmExistingStockNewDealRequestPaymentTransfer);
    this.postRejectNewDealRequest = this.mkPostFn(api.rejectNewDealRequest);
    this.postVoidNewDealRequest = this.mkPostFn(api.voidNewDealRequest);
    this.postConfirmPaymentNewDealRequest = this.mkPostFn(api.confirmPaymentNewDealRequest);
    this.postConfirmSupplierPaymentNewDealRequest = this.mkPostFn(api.confirmSupplierPaymentNewDealRequest);
    this.postOrganisationAdvanceNewStockNewDealRequest = this.mkPostFn(api.organisationAdvanceNewStockNewDealRequest);
    this.postOrganisationAdvanceExistingStockNewDealRequest = this.mkPostFn(api.organisationAdvanceExistingStockNewDealRequest);
    this.postGetOrganisationInventory = this.mkPostFn(api.getOrganisationInventory);
    this.postGetOrganisationInventoryByProductIds = this.mkPostFn(api.getOrganisationInventoryByProductIds);
    this.postCheckIfProductCodeExists = this.mkPostFn(api.checkIfProductCodeExists);
    this.postGetProducts = this.mkPostFn(api.getProducts);
    this.getGetAllRatesCurves = this.mkGetFn(api.getAllRatesCurves);
    this.getCheckRestateAuth = this.mkGetFn(api.checkRestateAuth);
    this.postGetRatesCurve = this.mkPostFn(api.getRatesCurve);
    this.postUpdateRatesCurve = this.mkPostFn(api.updateRatesCurve);
    this.getViewPurchasedStock = this.mkGetFn(api.viewPurchasedStock);
    this.getViewPurchasedStockCsv = this.mkGetFn(api.viewPurchasedStockCSV);
    this.getViewSoldStock = this.mkGetFn(api.viewSoldStock);
    this.getViewSoldStockCsv = this.mkGetFn(api.viewSoldStockCSV);
    this.getViewCapitalisedExpenses = this.mkGetFn(api.viewCapitalisedExpenses);
    this.getViewCapitalisedExpensesCsv = this.mkGetFn(api.viewCapitalisedExpensesCSV);
    this.postPreviewCapitalisedExpense = this.mkPostFn(api.previewCapitalisedExpense);
    this.postCreateCapitalisedExpense = this.mkPostFn(api.createCapitalisedExpense);
    this.postTrueLayerAuthorisation = this.mkPostFn(api.trueLayerAuthorisation);
    this.getTrueLayerCallback = this.mkGetFn(api.trueLayerCallback);
    this.postVisionAuthorisation = this.mkPostFn(api.visionAuthorisation);
    this.postProductMovementReport = this.mkPostFn(api.productMovementReport);
    this.postReportingEval = this.mkPostFn(api.reportingEval);
    this.postReportingAsyncRequest = this.mkPostFn(api.reportingAsyncRequest);
    this.postReportingAsyncResponse = this.mkPostFn(api.reportingAsyncResponse);
    this.postQrGenerateCode = this.mkPostFn(api.qrGenerateCode);
    this.postQrLinkDealLeg = this.mkPostFn(api.qrLinkDealLeg);
    this.postQrProductInfo = this.mkPostFn(api.qrProductInfo);
    this.postCreateStockMovementDealRoll = this.mkPostFn(api.createStockMovementDealRoll);
    this.postListNominatedPurchasers = this.mkPostFn(api.listNominatedPurchasers);
    this.getListPurchaserCreditLimitDetails = this.mkGetFn(api.listPurchaserCreditLimitDetails);
    this.postUpdatePurchaser = this.mkPostFn(api.updatePurchaser);
    this.postGetNominatedPurchaserDetailsView = this.mkPostFn(api.getNominatedPurchaserDetailsView);
    this.postGetNominatedPurchasersForOrg = this.mkPostFn(api.getNominatedPurchasersForOrg);
    this.postGetNominatedPurchaserIndexItemsForOrg = this.mkPostFn(api.getNominatedPurchaserIndexItemsForOrg);
    this.postGetNominatedPurchaserOutstandingBalanceSummaryPdf = this.mkPostFn(api.getNominatedPurchaserOutstandingBalanceSummaryPDF);
    this.postGetNominatedPurchaserSavedDeliveryInfoList = this.mkPostFn(api.getNominatedPurchaserSavedDeliveryInfoList);
    this.postGetOrgCustomerSavedDeliveryInfoList = this.mkPostFn(api.getOrgCustomerSavedDeliveryInfoList);
    this.postGetNominatedPurchasersForPurchaser = this.mkPostFn(api.getNominatedPurchasersForPurchaser);
    this.postGetPurchaseRequestsForPurchaser = this.mkPostFn(api.getPurchaseRequestsForPurchaser);
    this.postGetPurchaseRequestBreakdownForPurchaser = this.mkPostFn(api.getPurchaseRequestBreakdownForPurchaser);
    this.postGetNominatedPurchaserPurchaseRequests = this.mkPostFn(api.getNominatedPurchaserPurchaseRequests);
    this.postGetPurchaseRequestsForOrganisation = this.mkPostFn(api.getPurchaseRequestsForOrganisation);
    this.postGeneratePurchaseRequestReportForOrgAndSendEmail = this.mkPostFn(api.generatePurchaseRequestReportForOrgAndSendEmail);
    this.postGetPurchaseRequestDetailsForOrganisation = this.mkPostFn(api.getPurchaseRequestDetailsForOrganisation);
    this.postGetPurchaseRequestDetailsForPurchaser = this.mkPostFn(api.getPurchaseRequestDetailsForPurchaser);
    this.postGetNominatedPurchaserTermsForPurchaser = this.mkPostFn(api.getNominatedPurchaserTermsForPurchaser);
    this.postOrganisationMarkPurchaseRequestReadyForCollection = this.mkPostFn(api.organisationMarkPurchaseRequestReadyForCollection);
    this.postPurchaserRejectPurchaseRequest = this.mkPostFn(api.purchaserRejectPurchaseRequest);
    this.postPurchaserAcceptPurchaseRequest = this.mkPostFn(api.purchaserAcceptPurchaseRequest);
    this.postMarkPurchaseRequestCollected = this.mkPostFn(api.markPurchaseRequestCollected);
    this.postMarkPurchaseRequestDelivered = this.mkPostFn(api.markPurchaseRequestDelivered);
    this.postAdminMarkPurchaseRequestOrganisationPaid = this.mkPostFn(api.adminMarkPurchaseRequestOrganisationPaid);
    this.postAdminMarkPurchaseRequestPurchaserPaid = this.mkPostFn(api.adminMarkPurchaseRequestPurchaserPaid);
    this.postCreatePurchaseRequest = this.mkPostFn(api.createPurchaseRequest);
    this.postEditPurchaseRequest = this.mkPostFn(api.editPurchaseRequest);
    this.postCancelPurchaseRequest = this.mkPostFn(api.cancelPurchaseRequest);
    this.postGetOutgoingOrdersForStorageLocation = this.mkPostFn(api.getOutgoingOrdersForStorageLocation);
    this.postGetUploadUrl = this.mkPostFn(api.getUploadUrl);
    this.postGetPublicAssetUploadUrl = this.mkPostFn(api.getPublicAssetUploadUrl);
    this.postGetDownloadUrl = this.mkPostFn(api.getDownloadUrl);
    this.postGenerateInvoicePdf = this.mkPostFn(api.generateInvoicePdf);
    this.postAddLogoToOrganisation = this.mkPostFn(api.addLogoToOrganisation);
    this.postGetPurchaseRequestTimeline = this.mkPostFn(api.getPurchaseRequestTimeline);
    this.postGetPurchaseRequestTimelinePreview = this.mkPostFn(api.getPurchaseRequestTimelinePreview);
    this.postThirdPartySalesSummaryById = this.mkPostFn(api.thirdPartySalesSummaryById);
    this.postThirdPartySalesSummaryByDate = this.mkPostFn(api.thirdPartySalesSummaryByDate);
    this.postThirdPartySalesSummaryPreview = this.mkPostFn(api.thirdPartySalesSummaryPreview);
    this.postAmendTradeSaleSummaryPreview = this.mkPostFn(api.amendTradeSaleSummaryPreview);
    this.postGetPurchaseRequestFinishableProducts = this.mkPostFn(api.getPurchaseRequestFinishableProducts);
    this.postGetProductionOptionsForFinishedProducts = this.mkPostFn(api.getProductionOptionsForFinishedProducts);
    this.postGetProductCodeToProductMap = this.mkPostFn(api.getProductCodeToProductMap);
    this.postGetStorageLocationStockAdjustments = this.mkPostFn(api.getStorageLocationStockAdjustments);
    this.postCreateNegativeStockAdjustment = this.mkPostFn(api.createNegativeStockAdjustment);
    this.postPreviewNegativeStockAdjustment = this.mkPostFn(api.previewNegativeStockAdjustment);
    this.postGetNegativeStockAdjustmentDetails = this.mkPostFn(api.getNegativeStockAdjustmentDetails);
    this.postGetStorageLocationProductHoldings = this.mkPostFn(api.getStorageLocationProductHoldings);
    this.postCreatePositiveStockAdjustment = this.mkPostFn(api.createPositiveStockAdjustment);
    this.postGetPositiveStockAdjustmentDetails = this.mkPostFn(api.getPositiveStockAdjustmentDetails);
    this.getGetLcbHeldOrders = this.mkGetFn(api.getLcbHeldOrders);
    this.postActionLinkSupplierPurchaseOrders = this.mkPostFn(api.actionLinkSupplierPurchaseOrders);
    this.postActionLinkSupplierAcceptNewDealRequest = this.mkPostFn(api.actionLinkSupplierAcceptNewDealRequest);
    this.postActionLinkGetPurchaseRequestBreakdownForPurchaser = this.mkPostFn(api.actionLinkGetPurchaseRequestBreakdownForPurchaser);
    this.postActionLinkGetNominatedPurchaserTermsForPurchaser = this.mkPostFn(api.actionLinkGetNominatedPurchaserTermsForPurchaser);
    this.postActionLinkGetPurchaseRequestDetailsForPurchaser = this.mkPostFn(api.actionLinkGetPurchaseRequestDetailsForPurchaser);
    this.postActionLinkPurchaserRejectPurchaseRequest = this.mkPostFn(api.actionLinkPurchaserRejectPurchaseRequest);
    this.postActionLinkPurchaserAcceptPurchaseRequest = this.mkPostFn(api.actionLinkPurchaserAcceptPurchaseRequest);
    this.postActionLinkGetPurchaserPurchaseRequestTimeline = this.mkPostFn(api.actionLinkGetPurchaserPurchaseRequestTimeline);
    this.postConfirmTradeSalesOrderAuthorizationLink = this.mkPostFn(api.confirmTradeSalesOrderAuthorizationLink);
    this.postGenerateSupplierActionLinkParams = this.mkPostFn(api.generateSupplierActionLinkParams);
    this.postGeneratePurchaserActionLinkParams = this.mkPostFn(api.generatePurchaserActionLinkParams);
    this.postSendTradeSalesOrderAuthorizationForOrg = this.mkPostFn(api.sendTradeSalesOrderAuthorizationForOrg);
    this.getGetOrganisationCreditLimits = this.mkGetFn(api.getOrganisationCreditLimits);
    this.getGetThirdPartySalePaymentsToMake = this.mkGetFn(api.getThirdPartySalePaymentsToMake);
    this.getGetExistingStockProcurementPaymentsToMake = this.mkGetFn(api.getExistingStockProcurementPaymentsToMake);
    this.getGetNewStockProcurementPaymentsToMake = this.mkGetFn(api.getNewStockProcurementPaymentsToMake);
    this.postGetUpdatedThirdPartySaleFinalFxAmountToPay = this.mkPostFn(api.getUpdatedThirdPartySaleFinalFxAmountToPay);
    this.postGetDecisionRequiredOrganisationExpiringStockViews = this.mkPostFn(api.getDecisionRequiredOrganisationExpiringStockViews);
    this.postGetOrganisationExpiringStockViewsToBeRepurchased = this.mkPostFn(api.getOrganisationExpiringStockViewsToBeRepurchased);
    this.postRequestToRollExpiringStock = this.mkPostFn(api.requestToRollExpiringStock);
    this.postGetOrganisationDealRenewalsRequestedStock = this.mkPostFn(api.getOrganisationDealRenewalsRequestedStock);
    this.postGetOrganisationDealExtensionRequestDetails = this.mkPostFn(api.getOrganisationDealExtensionRequestDetails);
    this.postProgressDealExtensionRequestState = this.mkPostFn(api.progressDealExtensionRequestState);
    this.postGetOrganisationCompletedDealExtensionRequests = this.mkPostFn(api.getOrganisationCompletedDealExtensionRequests);
    this.postGetOrganisationImportantReminders = this.mkPostFn(api.getOrganisationImportantReminders);
    this.postGetDutyForProductQuantities = this.mkPostFn(api.getDutyForProductQuantities);
    this.postCreateWorkflow = this.mkPostFn(api.createWorkflow);
    this.postTransitionWorkflow = this.mkPostFn(api.transitionWorkflow);
    this.postGetContractNote = this.mkPostFn(api.getContractNote);
    this.postGetContractNoteView = this.mkPostFn(api.getContractNoteView);
    this.postPreviewContractNote = this.mkPostFn(api.previewContractNote);
    this.postCreateContractNote = this.mkPostFn(api.createContractNote);
    this.postOrgWfQuery = this.mkPostFn(api.orgWfQuery);
    this.postRevaluationRequestOverview = this.mkPostFn(api.revaluationRequestOverview);
    this.postRevaluationDetails = this.mkPostFn(api.revaluationDetails);
    this.postProgressRevaluationRequestState = this.mkPostFn(api.progressRevaluationRequestState);
    this.postSaveProductSalePrices = this.mkPostFn(api.saveProductSalePrices);
    this.postGetProductSalePrices = this.mkPostFn(api.getProductSalePrices);
    this.postOrgLookupProducts = this.mkPostFn(api.orgLookupProducts);
    this.postOrgGetProductQuantitiesAvailableToSell = this.mkPostFn(api.orgGetProductQuantitiesAvailableToSell);
    this.postOrgGetStoreConfigs = this.mkPostFn(api.orgGetStoreConfigs);
    this.postOrgGetStoreAllocationsForNomPurchaser = this.mkPostFn(api.orgGetStoreAllocationsForNomPurchaser);
    this.postOrgSaveStorefrontConfigForNominatedPurchasers = this.mkPostFn(api.orgSaveStorefrontConfigForNominatedPurchasers);
    this.postOrgSetStorefrontEnablement = this.mkPostFn(api.orgSetStorefrontEnablement);
    this.postBuyerGetStorefrontConfig = this.mkPostFn(api.buyerGetStorefrontConfig);
    this.postBuyerGetStorefrontProducts = this.mkPostFn(api.buyerGetStorefrontProducts);
    this.postBuyerGetStorefrontSavedDeliveryDetails = this.mkPostFn(api.buyerGetStorefrontSavedDeliveryDetails);
    this.postBuyerEstimateDeliveryFees = this.mkPostFn(api.buyerEstimateDeliveryFees);
    this.postStorageLocationSupportsDeliveryCalculation = this.mkPostFn(api.storageLocationSupportsDeliveryCalculation);
    this.postBuyerSubmitStorefrontOrder = this.mkPostFn(api.buyerSubmitStorefrontOrder);
    this.postSettlementCreditDetails = this.mkPostFn(api.settlementCreditDetails);
    this.postCreateOrUpdateCreditLimit = this.mkPostFn(api.createOrUpdateCreditLimit);
    this.postVerifyAdminAccessToken = this.mkPostFn(api.verifyAdminAccessToken);
    this.postTriggerRepurchaseStockAccountingEvent = this.mkPostFn(api.triggerRepurchaseStockAccountingEvent);
    this.postTriggerTradeSaleStateChangeAccountingEvent = this.mkPostFn(api.triggerTradeSaleStateChangeAccountingEvent);
    this.postTriggerNewDealReqStateChangeAccountingEvent = this.mkPostFn(api.triggerNewDealReqStateChangeAccountingEvent);
    this.postProcessUnmatchedInvoices = this.mkPostFn(api.processUnmatchedInvoices);
    this.postTestInternalApi = this.mkPostFn(api.testInternalApi);
    this.postGetDashboardSalesData = this.mkPostFn(api.getDashboardSalesData);
    this.postGetDashboardExpiringDeals = this.mkPostFn(api.getDashboardExpiringDeals);
    this.postGetDashboardStockBalances = this.mkPostFn(api.getDashboardStockBalances);
  }

  /** Login a user */
  async login(req: LoginReq): Promise<LoginResp> {
    return this.postLogin.call(req);
  }

  /** Gets the logged in user details */
  async whoAmI(): Promise<UserProfile> {
    return this.getWhoAmI.call();
  }

  /** Returns the memberships to the various entities that this user has */
  async getMemberships(): Promise<UserMembership> {
    return this.getGetMemberships.call();
  }

  async logClientErrorPublic(req: ClientLogReq): Promise<Unit> {
    return this.postLogClientErrorPublic.call(req);
  }

  async logClientErrorUser(req: ClientLogReq): Promise<Unit> {
    return this.postLogClientErrorUser.call(req);
  }

  /** Forgot password */
  async forgotUserPassword(req: UserForgotPasswordReq): Promise<Unit> {
    return this.postForgotUserPassword.call(req);
  }

  /** Lets a user reset their password */
  async resetUserPasswordAction(req: UserResetPasswordActionReq): Promise<Unit> {
    return this.postResetUserPasswordAction.call(req);
  }

  /** Create a list of new purchasers */
  async createPurchasers(req: CreatePurchaserAndNomPurchaserReq[]): Promise<PurchaserId[]> {
    return this.postCreatePurchasers.call(req);
  }

  async getLocationsProductListings(req: LocationsProductListingsReq): Promise<Map<WithDbId<StorageLocation>,ProductListing[]>> {
    return this.postGetLocationsProductListings.call(req);
  }

  async getOrgProductListingsAtLocation(req: OrgLocationProductListingsReq): Promise<ProductListing[]> {
    return this.postGetOrgProductListingsAtLocation.call(req);
  }

  async getThirdPartySaleFinishedProductListings(req: LocationsProductListingsReq): Promise<Map<WithDbId<StorageLocation>,ThirdPartySaleFinishedProductListing[]>> {
    return this.postGetThirdPartySaleFinishedProductListings.call(req);
  }

  async getThirdPartySaleFinishableProductListings(req: LocationsProductListingsReq): Promise<Map<WithDbId<StorageLocation>,ThirdPartySaleFinishableProductListing[]>> {
    return this.postGetThirdPartySaleFinishableProductListings.call(req);
  }

  async getOrganisationDeliveryLocations(req: OrganisationReq): Promise<WithDbId<OrganisationDeliveryLocation>[]> {
    return this.postGetOrganisationDeliveryLocations.call(req);
  }

  async ackSaleOrder(req: SaleOrderAckReq): Promise<SaleOrderId> {
    return this.postAckSaleOrder.call(req);
  }

  async cancelSaleOrder(req: SaleOrderCancelReq): Promise<SaleOrderId> {
    return this.postCancelSaleOrder.call(req);
  }

  async createSaleOrder(req: SaleOrderCreateReq): Promise<SaleOrderCreateResp> {
    return this.postCreateSaleOrder.call(req);
  }

  async createOrUpdateNewStockNewDealRequest(req: NewStockNewDealReq): Promise<NewDealRequestId> {
    return this.postCreateOrUpdateNewStockNewDealRequest.call(req);
  }

  async createOrUpdateExistingStockNewDealRequest(req: ExistingStockNewDealReq): Promise<NewDealRequestId> {
    return this.postCreateOrUpdateExistingStockNewDealRequest.call(req);
  }

  async releaseSaleOrder(req: SaleOrderReleaseReq): Promise<SaleOrderId> {
    return this.postReleaseSaleOrder.call(req);
  }

  async getSaleOrder(req: SaleOrderGetReq): Promise<SaleOrderDetailsView> {
    return this.postGetSaleOrder.call(req);
  }

  async getProductionOrder(req: ProductionOrderReq): Promise<ProductionOrderDetailsView> {
    return this.postGetProductionOrder.call(req);
  }

  async getDealLegRepurchaseOrder(req: DealLegRepurchaseOrderReq): Promise<DealLegRepurchaseOrderPreview> {
    return this.postGetDealLegRepurchaseOrder.call(req);
  }

  async getSaleOrderPreview(req: SaleOrderPreviewReq): Promise<SaleOrderPreview> {
    return this.postGetSaleOrderPreview.call(req);
  }

  async getStorageLocations(req: GetStorageLocationsReq): Promise<StorageLocationView[]> {
    return this.postGetStorageLocations.call(req);
  }

  async getCarriers(req: GetCarrierReq): Promise<WithDbId<Carrier>[]> {
    return this.postGetCarriers.call(req);
  }

  async getOrgExistingProducts(req: OrgExistingProductsReq): Promise<ExistingProductsResp> {
    return this.postGetOrgExistingProducts.call(req);
  }

  async getAllNominatedPurchaserTerms(): Promise<WithDbId<NominatedPurchaserTerms>[]> {
    return this.getGetAllNominatedPurchaserTerms.call();
  }

  async getStockData(req: StockDataReq): Promise<StockListing[]> {
    return this.postGetStockData.call(req);
  }

  async getStockTopLevelUnitTypes(req: OrganisationReq): Promise<Set<TopLevelUnitType>> {
    return this.postGetStockTopLevelUnitTypes.call(req);
  }

  async getStockDataCounts(req: OrganisationReq): Promise<Map<TopLevelUnitType,StockDataCounts>> {
    return this.postGetStockDataCounts.call(req);
  }

  async getStock(req: GetAvailableStockReq): Promise<DetailedPhysicalStock[]> {
    return this.postGetStock.call(req);
  }

  async getProductBalances(req: ProductBalancesReq): Promise<Map<TopLevelUnitType,ProductBalance[]>> {
    return this.postGetProductBalances.call(req);
  }

  /** returns a breakdown list of reserved for production units for a specific product */
  async getProductReservationsAtLoc(req: ProductReservationsReq): Promise<ProductReservationsResp> {
    return this.postGetProductReservationsAtLoc.call(req);
  }

  async getProductTypeBalancesCSV(req: StorageLocProductBalanceCSVReq): Promise<CSVData<string>> {
    return this.postGetProductTypeBalancesCsv.call(req);
  }

  async getOrganisationAvailableStockCSV(req: OrganisationAvailableStockReq): Promise<OrganisationAvailableStockViewCSV> {
    return this.postGetOrganisationAvailableStockCsv.call(req);
  }

  async getFspByDate(req: DealLegFspRequest): Promise<Map<DbKey<DealLeg>,CalculatedFsp>> {
    return this.postGetFspByDate.call(req);
  }

  async getFspDetailsForDate(req: DealLegFspRequest): Promise<Map<DbKey<DealLeg>,CalculatedFspDetails>> {
    return this.postGetFspDetailsForDate.call(req);
  }

  async getRepurchaseSaleOrders(req: OrganisationReq): Promise<WithDbId<SaleOrder>[]> {
    return this.postGetRepurchaseSaleOrders.call(req);
  }

  async getLossSaleOrders(req: OrganisationReq): Promise<WithDbId<SaleOrder>[]> {
    return this.postGetLossSaleOrders.call(req);
  }

  async outstandingInvoiceList(): Promise<InvoiceListItem[]> {
    return this.getOutstandingInvoiceList.call();
  }

  async previewProductionOrderTotals(req: PreviewProductionOrderTotalsReq): Promise<ProductionOrderTotals> {
    return this.postPreviewProductionOrderTotals.call(req);
  }

  async createProductionOrder(req: ProductionOrderCreateReq): Promise<ProductionOrderCreateResp> {
    return this.postCreateProductionOrder.call(req);
  }

  async acceptProductionOrder(req: ProductionOrderReq): Promise<Unit> {
    return this.postAcceptProductionOrder.call(req);
  }

  async completeProductionOrderTask(req: CreateProductionOrderTaskRunReq): Promise<CreateProductionOrderTaskRunResp> {
    return this.postCompleteProductionOrderTask.call(req);
  }

  async cancelProductionOrder(req: ProductionOrderReq): Promise<Unit> {
    return this.postCancelProductionOrder.call(req);
  }

  async rejectProductionOrder(req: RejectProductionOrderReq): Promise<Unit> {
    return this.postRejectProductionOrder.call(req);
  }

  async getOrganisationProductionOrders(req: OrganisationReq): Promise<ProductionOrderListingView[]> {
    return this.postGetOrganisationProductionOrders.call(req);
  }

  async getStorageLocationProductionOrders(req: StorageLocationReq): Promise<ProductionOrderListingView[]> {
    return this.postGetStorageLocationProductionOrders.call(req);
  }

  async getProductFinishingServices(req: SourceProductProductionServicesReq): Promise<Map<WithDbId<FinishingService>,WithDbId<Product>[]>> {
    return this.postGetProductFinishingServices.call(req);
  }

  async getProductToFinishingServicesMap(req: FinishingServicesByOrgAndStorageLocReq): Promise<Map<DbKey<Product>,WithDbId<FinishingService>[]>> {
    return this.postGetProductToFinishingServicesMap.call(req);
  }

  async productSearch(req: ProductSearchQueryReq): Promise<WithDbId<Product>[]> {
    return this.postProductSearch.call(req);
  }

  async productDealLegSearch(req: ProductDealLegSearchQueryReq): Promise<WithDbId<Product>[]> {
    return this.postProductDealLegSearch.call(req);
  }

  async supplierSearch(req: SearchQueryReq): Promise<WithDbId<Supplier>[]> {
    return this.postSupplierSearch.call(req);
  }

  async getOrgSupplier(req: SupplierId): Promise<WithDbId<Supplier>> {
    return this.postGetOrgSupplier.call(req);
  }

  async supplierPurchaseOrders(req: SupplierPurchaseOrdersListingReq): Promise<Paginated<SupplierPOView>> {
    return this.postSupplierPurchaseOrders.call(req);
  }

  async supplierAcceptNewDealRequest(req: SupplierAcceptNewDealRequestReq): Promise<SupplierNewDealRequestActionResp> {
    return this.postSupplierAcceptNewDealRequest.call(req);
  }

  async supplierUpdateNewDealRequest(req: SupplierUpdateNewDealRequestReq): Promise<SupplierNewDealRequestActionResp> {
    return this.postSupplierUpdateNewDealRequest.call(req);
  }

  async getNewDealRequests(req: NewDealRequestQueryReq): Promise<Paginated<NewDealRequestQueryResp>> {
    return this.postGetNewDealRequests.call(req);
  }

  async getOverdueNewDealRequests(): Promise<NewDealRequestView[]> {
    return this.getGetOverdueNewDealRequests.call();
  }

  async getPurchaseRequestsForAdmin(req: AdminGetPurchaseRequestReq): Promise<PurchaseRequestView[]> {
    return this.postGetPurchaseRequestsForAdmin.call(req);
  }

  async getPurchaseRequestForAdmin(req: PurchaseRequestId): Promise<AdminPurchaseRequestDetailsView> {
    return this.postGetPurchaseRequestForAdmin.call(req);
  }

  async getNewDealRequestDetails(req: NewDealRequestDetailsReq): Promise<NewDealRequestView> {
    return this.postGetNewDealRequestDetails.call(req);
  }

  async getStorageLocNewDealRequestShipments(req: StorageLocNewDealRequestShipmentReq): Promise<StorageLocNewDealRequestShipmentResp> {
    return this.postGetStorageLocNewDealRequestShipments.call(req);
  }

  async storageLocConfirmDelivery(req: StorageLocConfirmDeliveryReq): Promise<StorageLocConfirmDeliveryResp> {
    return this.postStorageLocConfirmDelivery.call(req);
  }

  async cancelNewDealRequest(req: NewDealRequestId): Promise<NewDealRequestCancellationResp> {
    return this.postCancelNewDealRequest.call(req);
  }

  async getNewDealRequestsForCarrier(req: NewDealRequestsForCarrierReq): Promise<Paginated<NewDealRequestCarrierView>> {
    return this.postGetNewDealRequestsForCarrier.call(req);
  }

  async getNewDealRequestsForOrganisation(req: NewDealRequestsForOrganisationReq): Promise<Paginated<NewDealRequestOrganisationView>> {
    return this.postGetNewDealRequestsForOrganisation.call(req);
  }

  async getInProgressNewDealRequestsOverview(req: OrganisationReq): Promise<InProgressNewDealRequestOverview[]> {
    return this.postGetInProgressNewDealRequestsOverview.call(req);
  }

  async carrierAdvanceNewDeal(req: CarrierAdvanceNewDealReq): Promise<CarrierAdvanceNewDealResp> {
    return this.postCarrierAdvanceNewDeal.call(req);
  }

  async previewNewDealRequestLineItems(req: PreviewNewDealRequestProductLineItemsReq): Promise<PreviewNewDealRequestProductLineItemsResp> {
    return this.postPreviewNewDealRequestLineItems.call(req);
  }

  /** Returns a valuation preview for an organisation while setting up a new [new deal request] */
  async organisationPreviewNewDealRequest(req: OrganisationPreviewNewDealRequestReq): Promise<OrganisationPreviewNewDealRequestResp> {
    return this.postOrganisationPreviewNewDealRequest.call(req);
  }

  /** Ferovinum HQ confirms a new deal request by setting the deal terms */
  async confirmNewStockNewDealRequest(req: ConfirmNewDealRequestReq): Promise<ConfirmNewDealRequestResp> {
    return this.postConfirmNewStockNewDealRequest.call(req);
  }

  async confirmExistingStockNewDealRequest(req: ConfirmExistingStockNewDealRequestReq): Promise<ConfirmExistingStockNewDealRequestResp> {
    return this.postConfirmExistingStockNewDealRequest.call(req);
  }

  async confirmExistingStockNewDealRequestStockOwnershipTransfer(req: StockOwnershipTransferConfirmationReq): Promise<StockOwnershipTransferConfirmationRequestResp> {
    return this.postConfirmExistingStockNewDealRequestStockOwnershipTransfer.call(req);
  }

  async confirmExistingStockNewDealRequestPaymentTransfer(req: PaymentTransferConfirmationReq): Promise<PaymentTransferConfirmationRequestResp> {
    return this.postConfirmExistingStockNewDealRequestPaymentTransfer.call(req);
  }

  /** Ferovinum HQ rejects a new deal request */
  async rejectNewDealRequest(req: RejectNewDealRequestReq): Promise<RejectNewDealRequestResp> {
    return this.postRejectNewDealRequest.call(req);
  }

  /** Ferovinum HQ voids a new deal request */
  async voidNewDealRequest(req: VoidNewDealReq): Promise<VoidNewDealResp> {
    return this.postVoidNewDealRequest.call(req);
  }

  /** Ferovinum HQ confirms that a payment attached to the new deal request has been paid (deposit payment, supplier payment or carrier payment) */
  async confirmPaymentNewDealRequest(req: ConfirmPaymentNewDealRequestReq): Promise<ConfirmPaymentNewDealRequestResp> {
    return this.postConfirmPaymentNewDealRequest.call(req);
  }

  /** Ferovinum HQ confirms that a supplier payment */
  async confirmSupplierPaymentNewDealRequest(req: ConfirmSupplierPaymentNewDealRequestReq): Promise<ConfirmPaymentNewDealRequestResp> {
    return this.postConfirmSupplierPaymentNewDealRequest.call(req);
  }

  /** Organisation advances a new deal request state */
  async organisationAdvanceNewStockNewDealRequest(req: OrganisationAdvanceNewStockNewDealRequestReq): Promise<OrganisationAdvanceNewDealRequestResp> {
    return this.postOrganisationAdvanceNewStockNewDealRequest.call(req);
  }

  async organisationAdvanceExistingStockNewDealRequest(req: OrganisationAdvanceExistingStockNewDealRequestReq): Promise<OrganisationAdvanceNewDealRequestResp> {
    return this.postOrganisationAdvanceExistingStockNewDealRequest.call(req);
  }

  /** Organisation inventory view */
  async getOrganisationInventory(req: OrganisationStockReq): Promise<Paginated<OrganisationProductInventoryView>> {
    return this.postGetOrganisationInventory.call(req);
  }

  /** Organisation inventory view by product ids */
  async getOrganisationInventoryByProductIds(req: OrganisationStockByProductIdsReq): Promise<OrganisationProductInventoryView[]> {
    return this.postGetOrganisationInventoryByProductIds.call(req);
  }

  /** Check if a product code already exists within an organisation */
  async checkIfProductCodeExists(req: CheckProductCodeReq): Promise<boolean> {
    return this.postCheckIfProductCodeExists.call(req);
  }

  /** Fetch a product based on the given product id */
  async getProducts(req: GetProductReq): Promise<GetProductResp> {
    return this.postGetProducts.call(req);
  }

  /** get a list of rates curves available (used to calculate monthly fees) */
  async getAllRatesCurves(): Promise<WithDbId<RatesCurve>[]> {
    return this.getGetAllRatesCurves.call();
  }

  async checkRestateAuth(): Promise<string> {
    return this.getCheckRestateAuth.call();
  }

  async getRatesCurve(req: GetRatesCurveReq): Promise<GetRatesCurveResp> {
    return this.postGetRatesCurve.call(req);
  }

  async updateRatesCurve(req: UpdateRatesCurveReq): Promise<UpdateRatesCurveResp> {
    return this.postUpdateRatesCurve.call(req);
  }

  /** View purchased stock (JSON - user token) */
  async viewPurchasedStock(): Promise<PurchasedStockView[]> {
    return this.getViewPurchasedStock.call();
  }

  /** View purchased stock (CSV - user token) */
  async viewPurchasedStockCSV(): Promise<PurchasedStockCSV> {
    return this.getViewPurchasedStockCsv.call();
  }

  /** View sold stock (JSON - user token) */
  async viewSoldStock(): Promise<SoldStockView[]> {
    return this.getViewSoldStock.call();
  }

  /** View sold stock (CSV - user token) */
  async viewSoldStockCSV(): Promise<SoldStockCSV> {
    return this.getViewSoldStockCsv.call();
  }

  /** View capitalised expenses (JSON - user token) */
  async viewCapitalisedExpenses(): Promise<CapitalisedExpensesView[]> {
    return this.getViewCapitalisedExpenses.call();
  }

  /** View capitalised expenses (CSV - user token) */
  async viewCapitalisedExpensesCSV(): Promise<CapitalisedExpensesCSV> {
    return this.getViewCapitalisedExpensesCsv.call();
  }

  async previewCapitalisedExpense(req: CreateCapitalisedExpenseReq): Promise<PreviewCapitalisedExpenseResp> {
    return this.postPreviewCapitalisedExpense.call(req);
  }

  async createCapitalisedExpense(req: CreateCapitalisedExpenseReq): Promise<CreateCapitalisedExpenseResp> {
    return this.postCreateCapitalisedExpense.call(req);
  }

  /** TrueLayer API OAuth */
  async trueLayerAuthorisation(req: TrueLayerProvider): Promise<string> {
    return this.postTrueLayerAuthorisation.call(req);
  }

  async trueLayerCallback(): Promise<Unit> {
    return this.getTrueLayerCallback.call();
  }

  /** Vision API connection authorisation */
  async visionAuthorisation(req: VisionEndpoint): Promise<string> {
    return this.postVisionAuthorisation.call(req);
  }

  async productMovementReport(req: ProductMovementReportReq): Promise<Maybe<ProductMovementReport>> {
    return this.postProductMovementReport.call(req);
  }

  async reportingEval(req: ReportReq): Promise<ReportResp> {
    return this.postReportingEval.call(req);
  }

  async reportingAsyncRequest(req: ReportReq): Promise<string> {
    return this.postReportingAsyncRequest.call(req);
  }

  async reportingAsyncResponse(req: string): Promise<(ReportResp|null)> {
    return this.postReportingAsyncResponse.call(req);
  }

  async qrGenerateCode(req: Unit): Promise<QrGenerateCodeResp> {
    return this.postQrGenerateCode.call(req);
  }

  async qrLinkDealLeg(req: QrLinkDealLegReq): Promise<boolean> {
    return this.postQrLinkDealLeg.call(req);
  }

  async qrProductInfo(req: string): Promise<(QrProductInfoResp|null)> {
    return this.postQrProductInfo.call(req);
  }

  async createStockMovementDealRoll(req: CreateStockMovementDealRollReq): Promise<CreateStockMovementDealRollResp> {
    return this.postCreateStockMovementDealRoll.call(req);
  }

  async listNominatedPurchasers(req: ListNominatedPurchaserDetailsReq): Promise<ListNominatedPurchaserDetailsResp> {
    return this.postListNominatedPurchasers.call(req);
  }

  async listPurchaserCreditLimitDetails(): Promise<PurchaserCreditLimitDetails[]> {
    return this.getListPurchaserCreditLimitDetails.call();
  }

  async updatePurchaser(req: UpdatePurchaserReq): Promise<Unit> {
    return this.postUpdatePurchaser.call(req);
  }

  async getNominatedPurchaserDetailsView(req: NominatedPurchaserReq): Promise<(NominatedPurchaserDetailsView|null)> {
    return this.postGetNominatedPurchaserDetailsView.call(req);
  }

  async getNominatedPurchasersForOrg(req: OrganisationReq): Promise<NominatedPurchaserDetailsView[]> {
    return this.postGetNominatedPurchasersForOrg.call(req);
  }

  async getNominatedPurchaserIndexItemsForOrg(req: OrganisationReq): Promise<NominatedPurchaserIndexItemView[]> {
    return this.postGetNominatedPurchaserIndexItemsForOrg.call(req);
  }

  async getNominatedPurchaserOutstandingBalanceSummaryPDF(req: NominatedPurchaserReq): Promise<string> {
    return this.postGetNominatedPurchaserOutstandingBalanceSummaryPdf.call(req);
  }

  async getNominatedPurchaserSavedDeliveryInfoList(req: NominatedPurchaserReq): Promise<SavedDeliveryInfo[]> {
    return this.postGetNominatedPurchaserSavedDeliveryInfoList.call(req);
  }

  async getOrgCustomerSavedDeliveryInfoList(req: OrganisationReq): Promise<OrgCustomerSavedDeliveryInfo[]> {
    return this.postGetOrgCustomerSavedDeliveryInfoList.call(req);
  }

  async getNominatedPurchasersForPurchaser(req: NominatedPurchasersForPurchaserReq): Promise<NominatedPurchasersForPurchaser[]> {
    return this.postGetNominatedPurchasersForPurchaser.call(req);
  }

  async getPurchaseRequestsForPurchaser(req: PurchaserPurchaseRequestsReq): Promise<PurchaserPurchaseRequestView[]> {
    return this.postGetPurchaseRequestsForPurchaser.call(req);
  }

  async getPurchaseRequestBreakdownForPurchaser(req: PurchaserPurchaseRequestReq): Promise<PurchaseRequestBreakdownForPurchaser> {
    return this.postGetPurchaseRequestBreakdownForPurchaser.call(req);
  }

  async getNominatedPurchaserPurchaseRequests(req: OrganisationNominatedPurchaserReq): Promise<WithDbId<PurchaseRequest>[]> {
    return this.postGetNominatedPurchaserPurchaseRequests.call(req);
  }

  async getPurchaseRequestsForOrganisation(req: OrganisationGetPurchaseRequestReq): Promise<PurchaseRequestView[]> {
    return this.postGetPurchaseRequestsForOrganisation.call(req);
  }

  async generatePurchaseRequestReportForOrgAndSendEmail(req: OrganisationPurchaseRequestsReportReq): Promise<OrganisationId> {
    return this.postGeneratePurchaseRequestReportForOrgAndSendEmail.call(req);
  }

  async getPurchaseRequestDetailsForOrganisation(req: PurchaseRequestId): Promise<OrganisationPurchaseRequestDetailsView> {
    return this.postGetPurchaseRequestDetailsForOrganisation.call(req);
  }

  async getPurchaseRequestDetailsForPurchaser(req: PurchaseRequestId): Promise<PurchaserPurchaseRequestView> {
    return this.postGetPurchaseRequestDetailsForPurchaser.call(req);
  }

  async getNominatedPurchaserTermsForPurchaser(req: PurchaseRequestId): Promise<NominatedPurchaserTerms> {
    return this.postGetNominatedPurchaserTermsForPurchaser.call(req);
  }

  async organisationMarkPurchaseRequestReadyForCollection(req: OrganisationPurchaseRequestReq): Promise<UpdatePurchaseRequestResp> {
    return this.postOrganisationMarkPurchaseRequestReadyForCollection.call(req);
  }

  async purchaserRejectPurchaseRequest(req: PurchaseRequestReq): Promise<UpdatePurchaseRequestResp> {
    return this.postPurchaserRejectPurchaseRequest.call(req);
  }

  async purchaserAcceptPurchaseRequest(req: PurchaserAcceptPurchaseRequestReq): Promise<UpdatePurchaseRequestResp> {
    return this.postPurchaserAcceptPurchaseRequest.call(req);
  }

  async markPurchaseRequestCollected(req: PurchaseRequestMarkDateReq): Promise<UpdatePurchaseRequestResp> {
    return this.postMarkPurchaseRequestCollected.call(req);
  }

  async markPurchaseRequestDelivered(req: PurchaseRequestMarkDateReq): Promise<UpdatePurchaseRequestResp> {
    return this.postMarkPurchaseRequestDelivered.call(req);
  }

  async adminMarkPurchaseRequestOrganisationPaid(req: UpdatePurchaseRequestOrganisationPaidReq): Promise<UpdatePurchaseRequestResp> {
    return this.postAdminMarkPurchaseRequestOrganisationPaid.call(req);
  }

  async adminMarkPurchaseRequestPurchaserPaid(req: UpdatePurchaseRequestPurchaserPaidReq): Promise<UpdatePurchaseRequestResp> {
    return this.postAdminMarkPurchaseRequestPurchaserPaid.call(req);
  }

  async createPurchaseRequest(req: CreatePurchaseRequestReq): Promise<CreatePurchaseRequestResp> {
    return this.postCreatePurchaseRequest.call(req);
  }

  async editPurchaseRequest(req: EditPurchaseRequestReq): Promise<EditPurchaseRequestResp> {
    return this.postEditPurchaseRequest.call(req);
  }

  async cancelPurchaseRequest(req: CancelPurchaseRequestReq): Promise<CancelPurchaseRequestResp> {
    return this.postCancelPurchaseRequest.call(req);
  }

  async getOutgoingOrdersForStorageLocation(req: GetOutgoingOrdersReq): Promise<GetOutgoingOrdersResp> {
    return this.postGetOutgoingOrdersForStorageLocation.call(req);
  }

  async getUploadUrl(req: GetUploadUrlReq): Promise<GetUploadUrlResp> {
    return this.postGetUploadUrl.call(req);
  }

  async getPublicAssetUploadUrl(req: GetUploadUrlReq): Promise<GetUploadUrlResp> {
    return this.postGetPublicAssetUploadUrl.call(req);
  }

  async getDownloadUrl(req: GetDownloadUrlReq): Promise<GetDownloadUrlResp> {
    return this.postGetDownloadUrl.call(req);
  }

  async generateInvoicePdf(req: InvoiceId): Promise<string> {
    return this.postGenerateInvoicePdf.call(req);
  }

  async addLogoToOrganisation(req: OrganisationLogoReq): Promise<Unit> {
    return this.postAddLogoToOrganisation.call(req);
  }

  async getPurchaseRequestTimeline(req: PurchaseRequestId): Promise<PurchaseRequestTimeline> {
    return this.postGetPurchaseRequestTimeline.call(req);
  }

  async getPurchaseRequestTimelinePreview(req: PreviewPurchaseRequestTimelineReq): Promise<PurchaseRequestTimeline> {
    return this.postGetPurchaseRequestTimelinePreview.call(req);
  }

  async thirdPartySalesSummaryById(req: PurchaseRequestId): Promise<ThirdPartySalesSummaryResp> {
    return this.postThirdPartySalesSummaryById.call(req);
  }

  async thirdPartySalesSummaryByDate(req: ThirdPartySalesSummaryByDateReq): Promise<ThirdPartySalesSummaryResp> {
    return this.postThirdPartySalesSummaryByDate.call(req);
  }

  async thirdPartySalesSummaryPreview(req: PurchaseRequestPreviewReq): Promise<ThirdPartySalesSummaryPreviewResp> {
    return this.postThirdPartySalesSummaryPreview.call(req);
  }

  async amendTradeSaleSummaryPreview(req: AmendPurchaseRequestPreviewReq): Promise<ThirdPartySalesSummaryPreviewResp> {
    return this.postAmendTradeSaleSummaryPreview.call(req);
  }

  /** Returns a list of finished products that can be added to a purchase request through a production order of the given source products for a given organisation and storage location */
  async getPurchaseRequestFinishableProducts(req: PurchaseRequestFinishableProductsReq): Promise<FinishableProductListing[]> {
    return this.postGetPurchaseRequestFinishableProducts.call(req);
  }

  /** Returns a map of production options, i.e. source product and finishing service that can be used to generate the specified finisable product */
  async getProductionOptionsForFinishedProducts(req: GetProductionOptionsForFinishedProductsMapReq): Promise<GetProductionOptionsForFinishedProductsMapResp> {
    return this.postGetProductionOptionsForFinishedProducts.call(req);
  }

  async getProductCodeToProductMap(req: OrganisationProductCodesReq): Promise<Map<StringNE,OrganisationProductResp>> {
    return this.postGetProductCodeToProductMap.call(req);
  }

  async getStorageLocationStockAdjustments(req: StorageLocTopLevelUnitTypeReq): Promise<Map<TopLevelUnitType,StockAdjustment[]>> {
    return this.postGetStorageLocationStockAdjustments.call(req);
  }

  async createNegativeStockAdjustment(req: CreateNegativeStockAdjustmentReq): Promise<CreateNegativeStockAdjustmentResp> {
    return this.postCreateNegativeStockAdjustment.call(req);
  }

  async previewNegativeStockAdjustment(req: PreviewNegativeStockAdjustmentSalesReq): Promise<PreviewNegativeStockAdjustmentSalesResp> {
    return this.postPreviewNegativeStockAdjustment.call(req);
  }

  async getNegativeStockAdjustmentDetails(req: NegativeStockAdjustmentDetailsViewReq): Promise<NegativeStockAdjustmentDetailsViewResp> {
    return this.postGetNegativeStockAdjustmentDetails.call(req);
  }

  async getStorageLocationProductHoldings(req: StorageLocationSearchReq): Promise<Map<TopLevelUnitType,Map<WithDbId<Product>,StorageLocationProductHolding[]>>> {
    return this.postGetStorageLocationProductHoldings.call(req);
  }

  async createPositiveStockAdjustment(req: CreatePositiveStockAdjustmentReq): Promise<CreatePositiveStockAdjustmentResp> {
    return this.postCreatePositiveStockAdjustment.call(req);
  }

  async getPositiveStockAdjustmentDetails(req: PositiveStockAdjustmentReq): Promise<PositiveStockAdjustmentDetailsView> {
    return this.postGetPositiveStockAdjustmentDetails.call(req);
  }

  async getLcbHeldOrders(): Promise<Map<string,StorageLocationLcbHeldOrders>> {
    return this.getGetLcbHeldOrders.call();
  }

  async actionLinkSupplierPurchaseOrders(req: SupplierPurchaseOrdersListingReq): Promise<SupplierPOView> {
    return this.postActionLinkSupplierPurchaseOrders.call(req);
  }

  async actionLinkSupplierAcceptNewDealRequest(req: SupplierAcceptNewDealRequestReq): Promise<SupplierNewDealRequestActionResp> {
    return this.postActionLinkSupplierAcceptNewDealRequest.call(req);
  }

  /** Purchaser Action Link Endpoints */
  async actionLinkGetPurchaseRequestBreakdownForPurchaser(req: PurchaserPurchaseRequestReq): Promise<PurchaseRequestBreakdownForPurchaser> {
    return this.postActionLinkGetPurchaseRequestBreakdownForPurchaser.call(req);
  }

  async actionLinkGetNominatedPurchaserTermsForPurchaser(req: PurchaseRequestId): Promise<NominatedPurchaserTerms> {
    return this.postActionLinkGetNominatedPurchaserTermsForPurchaser.call(req);
  }

  async actionLinkGetPurchaseRequestDetailsForPurchaser(req: PurchaseRequestId): Promise<PurchaserPurchaseRequestView> {
    return this.postActionLinkGetPurchaseRequestDetailsForPurchaser.call(req);
  }

  async actionLinkPurchaserRejectPurchaseRequest(req: PurchaseRequestReq): Promise<UpdatePurchaseRequestResp> {
    return this.postActionLinkPurchaserRejectPurchaseRequest.call(req);
  }

  async actionLinkPurchaserAcceptPurchaseRequest(req: PurchaserAcceptPurchaseRequestReq): Promise<UpdatePurchaseRequestResp> {
    return this.postActionLinkPurchaserAcceptPurchaseRequest.call(req);
  }

  async actionLinkGetPurchaserPurchaseRequestTimeline(req: PurchaseRequestId): Promise<PurchaseRequestTimeline> {
    return this.postActionLinkGetPurchaserPurchaseRequestTimeline.call(req);
  }

  async confirmTradeSalesOrderAuthorizationLink(req: Unit): Promise<Unit> {
    return this.postConfirmTradeSalesOrderAuthorizationLink.call(req);
  }

  /** END of Purchaser Action Link Endpoints Get accept new deal request action url for test purposes */
  async generateSupplierActionLinkParams(req: GenerateSupplierActionLinkReq): Promise<GenerateSupplierActionLinkResp> {
    return this.postGenerateSupplierActionLinkParams.call(req);
  }

  /** Get accept purchase request action url for test purposes */
  async generatePurchaserActionLinkParams(req: GeneratePurchaserActionLinkReq): Promise<GeneratePurchaserActionLinkResp> {
    return this.postGeneratePurchaserActionLinkParams.call(req);
  }

  /** Generates a email to the nominated purchaser with a link to accept the org to make orders on their behalf This will resend all the emails to the nominated purchasers for the given purchaser */
  async sendTradeSalesOrderAuthorizationForOrg(req: OrganisationId): Promise<Unit> {
    return this.postSendTradeSalesOrderAuthorizationForOrg.call(req);
  }

  /** Returns a summary of the credit limits for each organisation. Should only be able to be called by an admin */
  async getOrganisationCreditLimits(): Promise<GetOrganisationCreditLimitsResp> {
    return this.getGetOrganisationCreditLimits.call();
  }

  async getThirdPartySalePaymentsToMake(): Promise<ThirdPartySalePaymentToMake[]> {
    return this.getGetThirdPartySalePaymentsToMake.call();
  }

  async getExistingStockProcurementPaymentsToMake(): Promise<ExistingStockProcurementPaymentToMake[]> {
    return this.getGetExistingStockProcurementPaymentsToMake.call();
  }

  async getNewStockProcurementPaymentsToMake(): Promise<NewStockProcurementPaymentToMake[]> {
    return this.getGetNewStockProcurementPaymentsToMake.call();
  }

  async getUpdatedThirdPartySaleFinalFxAmountToPay(req: GetUpdatedFinalFxAmountToPayReq): Promise<BigDecimal> {
    return this.postGetUpdatedThirdPartySaleFinalFxAmountToPay.call(req);
  }

  /** Gets deal leg for an organisation that will expire within 30 days and that the org has not made any decision about */
  async getDecisionRequiredOrganisationExpiringStockViews(req: OrganisationReq): Promise<OrganisationExpiringStockView[]> {
    return this.postGetDecisionRequiredOrganisationExpiringStockViews.call(req);
  }

  /** Gets deal legs for an organisation that: - Will expire within 30 days and the org is intending to repurchase some or all units - Will expire within 30 days and Fero has rejected the expiry roll intention - Have already expired but before the overdue deadline */
  async getOrganisationExpiringStockViewsToBeRepurchased(req: OrganisationReq): Promise<OrganisationRepurchaseExpiringStockViewResp> {
    return this.postGetOrganisationExpiringStockViewsToBeRepurchased.call(req);
  }

  /** Sets the deal legs' expiry roll intention to the requested number of units to roll */
  async requestToRollExpiringStock(req: OrganisationExpiringStockRollRequest): Promise<OrganisationExpiringStockRollRequestResp> {
    return this.postRequestToRollExpiringStock.call(req);
  }

  /** Gets expiring stock that the org has sent a renewal request for. The returned objects can either be deal legs pending review from Ferovinum or it can be deal extension requests for those that have already been reviewed. */
  async getOrganisationDealRenewalsRequestedStock(req: OrganisationReq): Promise<OrganisationDealRenewalsRequestedStock> {
    return this.postGetOrganisationDealRenewalsRequestedStock.call(req);
  }

  async getOrganisationDealExtensionRequestDetails(req: DealExtensionRequestDetailsReq): Promise<OrganisationDealExtensionRequestDetailsView> {
    return this.postGetOrganisationDealExtensionRequestDetails.call(req);
  }

  /** Allows a user to progress the state of a deal extension request. The actions available for orgs are: accept terms, reject terms, mark invoice as paid */
  async progressDealExtensionRequestState(req: OrganisationProgressDealExtensionRequestReq): Promise<OrganisationProgressDealExtensionRequestResp> {
    return this.postProgressDealExtensionRequestState.call(req);
  }

  async getOrganisationCompletedDealExtensionRequests(req: OrganisationReq): Promise<MinimalDealExtensionRequestView[]> {
    return this.postGetOrganisationCompletedDealExtensionRequests.call(req);
  }

  /** Returns important reminders to be displayed for org users */
  async getOrganisationImportantReminders(req: OrganisationReq): Promise<OrganisationImportantReminders> {
    return this.postGetOrganisationImportantReminders.call(req);
  }

  /** Returns the duty for the supplied product quantities */
  async getDutyForProductQuantities(req: ProductDutyReq): Promise<ProductDutyResp> {
    return this.postGetDutyForProductQuantities.call(req);
  }

  /** Create new workflow with workflow actions. Only actions that are accepted by WorkflowController::handleStateCreation are valid. */
  async createWorkflow(req: WorkflowCreationReq): Promise<WorkflowResp> {
    return this.postCreateWorkflow.call(req);
  }

  async transitionWorkflow(req: WorkflowTransitionReq): Promise<WorkflowResp> {
    return this.postTransitionWorkflow.call(req);
  }

  async getContractNote(req: ContractNoteFetchReq): Promise<ContractNoteFetchResp> {
    return this.postGetContractNote.call(req);
  }

  async getContractNoteView(req: ContractNoteFetchReq): Promise<ContractNoteView> {
    return this.postGetContractNoteView.call(req);
  }

  async previewContractNote(req: ContractNotePreviewReq): Promise<ContractNotePreviewResp> {
    return this.postPreviewContractNote.call(req);
  }

  async createContractNote(req: ContractNoteSourceRequest): Promise<DbKey<ContractNote>> {
    return this.postCreateContractNote.call(req);
  }

  async orgWfQuery(req: OrgWfQuery): Promise<WithDbId<Workflow>[]> {
    return this.postOrgWfQuery.call(req);
  }

  /** Returns a list of revaluation requests associated with the organisation */
  async revaluationRequestOverview(req: OrganisationId): Promise<RevaluationRequestSummary[]> {
    return this.postRevaluationRequestOverview.call(req);
  }

  /** Returns details of a revaluation request */
  async revaluationDetails(req: RevaluationRequestId): Promise<RevaluationDetailsResp> {
    return this.postRevaluationDetails.call(req);
  }

  /** Allows org to progress the revaluation request state (accepted and rejected from created) */
  async progressRevaluationRequestState(req: ProgressRevaluationRequestReq): Promise<ProgressRevaluationRequestResp> {
    return this.postProgressRevaluationRequestState.call(req);
  }

  async saveProductSalePrices(req: PresetSalePricesUploadReq): Promise<Unit> {
    return this.postSaveProductSalePrices.call(req);
  }

  async getProductSalePrices(req: PresetSalePricesReq): Promise<ProductSalePriceInfo[]> {
    return this.postGetProductSalePrices.call(req);
  }

  async orgLookupProducts(req: OrgProductLookupReq): Promise<DbKey<Product>[]> {
    return this.postOrgLookupProducts.call(req);
  }

  async orgGetProductQuantitiesAvailableToSell(req: OrgGetProductReq): Promise<Map<DbKey<Product>,NumberOfUnits>> {
    return this.postOrgGetProductQuantitiesAvailableToSell.call(req);
  }

  async orgGetStoreConfigs(req: OrganisationId): Promise<NomPurchaserStorefrontConfigData[]> {
    return this.postOrgGetStoreConfigs.call(req);
  }

  async orgGetStoreAllocationsForNomPurchaser(req: NominatedPurchaserId): Promise<StorefrontProductAllocationData[]> {
    return this.postOrgGetStoreAllocationsForNomPurchaser.call(req);
  }

  async orgSaveStorefrontConfigForNominatedPurchasers(req: SaveStorefrontConfigsReq): Promise<Unit> {
    return this.postOrgSaveStorefrontConfigForNominatedPurchasers.call(req);
  }

  async orgSetStorefrontEnablement(req: OrgSetStorefrontEnablementReq): Promise<Unit> {
    return this.postOrgSetStorefrontEnablement.call(req);
  }

  async buyerGetStorefrontConfig(req: NominatedPurchaserId): Promise<StorefrontConfigResp> {
    return this.postBuyerGetStorefrontConfig.call(req);
  }

  async buyerGetStorefrontProducts(req: NominatedPurchaserId): Promise<StorefrontProductsResp> {
    return this.postBuyerGetStorefrontProducts.call(req);
  }

  async buyerGetStorefrontSavedDeliveryDetails(req: NominatedPurchaserId): Promise<SavedDeliveryInfo[]> {
    return this.postBuyerGetStorefrontSavedDeliveryDetails.call(req);
  }

  async buyerEstimateDeliveryFees(req: StorefrontOrder): Promise<DeliveryFee> {
    return this.postBuyerEstimateDeliveryFees.call(req);
  }

  async storageLocationSupportsDeliveryCalculation(req: StorageLocationId): Promise<boolean> {
    return this.postStorageLocationSupportsDeliveryCalculation.call(req);
  }

  async buyerSubmitStorefrontOrder(req: SubmitStorefrontOrderReq): Promise<SubmitStorefrontOrderResp> {
    return this.postBuyerSubmitStorefrontOrder.call(req);
  }

  async settlementCreditDetails(req: SettlementCreditDetailsReq): Promise<SettlementCreditDetailsResp> {
    return this.postSettlementCreditDetails.call(req);
  }

  async createOrUpdateCreditLimit(req: CreateOrUpdateSettlementCreditReq): Promise<CreateOrUpdateSettlementCreditResp> {
    return this.postCreateOrUpdateCreditLimit.call(req);
  }

  async verifyAdminAccessToken(req: Unit): Promise<TokenStatus> {
    return this.postVerifyAdminAccessToken.call(req);
  }

  async triggerRepurchaseStockAccountingEvent(req: SaleOrderId[]): Promise<Unit> {
    return this.postTriggerRepurchaseStockAccountingEvent.call(req);
  }

  async triggerTradeSaleStateChangeAccountingEvent(req: TradeSaleAccountingEventReq[]): Promise<Unit> {
    return this.postTriggerTradeSaleStateChangeAccountingEvent.call(req);
  }

  async triggerNewDealReqStateChangeAccountingEvent(req: NewDealRequestStateChangeAccountingEventReq[]): Promise<Unit> {
    return this.postTriggerNewDealReqStateChangeAccountingEvent.call(req);
  }

  async processUnmatchedInvoices(req: string[]): Promise<Unit> {
    return this.postProcessUnmatchedInvoices.call(req);
  }

  async testInternalApi(req: TestInternalApiReq): Promise<Unit> {
    return this.postTestInternalApi.call(req);
  }

  async getDashboardSalesData(req: DashboardDataReq): Promise<DashboardSalesResp[]> {
    return this.postGetDashboardSalesData.call(req);
  }

  async getDashboardExpiringDeals(req: DashboardDataReq): Promise<DashboardExpiringDealsResp[]> {
    return this.postGetDashboardExpiringDeals.call(req);
  }

  async getDashboardStockBalances(req: DashboardDataReq): Promise<DashboardStockBalancesResp[]> {
    return this.postGetDashboardStockBalances.call(req);
  }
};
